import Ws, { createContext as Ya, useContext as Ua, useState as ja, useRef as Zn, useEffect as Qn, useMemo as $a, createElement as Wa } from "react";
var Xn = { exports: {} }, wt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var is;
function Ha() {
  if (is)
    return wt;
  is = 1;
  var e = Ws, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, s = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(o, u, l) {
    var f, d = {}, h = null, S = null;
    l !== void 0 && (h = "" + l), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (S = u.ref);
    for (f in u)
      r.call(u, f) && !i.hasOwnProperty(f) && (d[f] = u[f]);
    if (o && o.defaultProps)
      for (f in u = o.defaultProps, u)
        d[f] === void 0 && (d[f] = u[f]);
    return { $$typeof: t, type: o, key: h, ref: S, props: d, _owner: s.current };
  }
  return wt.Fragment = n, wt.jsx = a, wt.jsxs = a, wt;
}
var St = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var as;
function Va() {
  return as || (as = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Ws, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), o = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), S = Symbol.for("react.offscreen"), p = Symbol.iterator, y = "@@iterator";
    function _(c) {
      if (c === null || typeof c != "object")
        return null;
      var m = p && c[p] || c[y];
      return typeof m == "function" ? m : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(c) {
      {
        for (var m = arguments.length, b = new Array(m > 1 ? m - 1 : 0), E = 1; E < m; E++)
          b[E - 1] = arguments[E];
        P("error", c, b);
      }
    }
    function P(c, m, b) {
      {
        var E = x.ReactDebugCurrentFrame, Y = E.getStackAddendum();
        Y !== "" && (m += "%s", b = b.concat([Y]));
        var H = b.map(function(C) {
          return String(C);
        });
        H.unshift("Warning: " + m), Function.prototype.apply.call(console[c], console, H);
      }
    }
    var D = !1, U = !1, $ = !1, W = !1, Ke = !1, $t;
    $t = Symbol.for("react.module.reference");
    function Wt(c) {
      return !!(typeof c == "string" || typeof c == "function" || c === r || c === i || Ke || c === s || c === l || c === f || W || c === S || D || U || $ || typeof c == "object" && c !== null && (c.$$typeof === h || c.$$typeof === d || c.$$typeof === a || c.$$typeof === o || c.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      c.$$typeof === $t || c.getModuleId !== void 0));
    }
    function We(c, m, b) {
      var E = c.displayName;
      if (E)
        return E;
      var Y = m.displayName || m.name || "";
      return Y !== "" ? b + "(" + Y + ")" : b;
    }
    function Nn(c) {
      return c.displayName || "Context";
    }
    function ue(c) {
      if (c == null)
        return null;
      if (typeof c.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof c == "function")
        return c.displayName || c.name || null;
      if (typeof c == "string")
        return c;
      switch (c) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case s:
          return "StrictMode";
        case l:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof c == "object")
        switch (c.$$typeof) {
          case o:
            var m = c;
            return Nn(m) + ".Consumer";
          case a:
            var b = c;
            return Nn(b._context) + ".Provider";
          case u:
            return We(c, c.render, "ForwardRef");
          case d:
            var E = c.displayName || null;
            return E !== null ? E : ue(c.type) || "Memo";
          case h: {
            var Y = c, H = Y._payload, C = Y._init;
            try {
              return ue(C(H));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ae = Object.assign, pe = 0, He, pt, X, Se, Ie, gt, Hr;
    function Vr() {
    }
    Vr.__reactDisabledLog = !0;
    function fa() {
      {
        if (pe === 0) {
          He = console.log, pt = console.info, X = console.warn, Se = console.error, Ie = console.group, gt = console.groupCollapsed, Hr = console.groupEnd;
          var c = {
            configurable: !0,
            enumerable: !0,
            value: Vr,
            writable: !0
          };
          Object.defineProperties(console, {
            info: c,
            log: c,
            warn: c,
            error: c,
            group: c,
            groupCollapsed: c,
            groupEnd: c
          });
        }
        pe++;
      }
    }
    function da() {
      {
        if (pe--, pe === 0) {
          var c = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ae({}, c, {
              value: He
            }),
            info: ae({}, c, {
              value: pt
            }),
            warn: ae({}, c, {
              value: X
            }),
            error: ae({}, c, {
              value: Se
            }),
            group: ae({}, c, {
              value: Ie
            }),
            groupCollapsed: ae({}, c, {
              value: gt
            }),
            groupEnd: ae({}, c, {
              value: Hr
            })
          });
        }
        pe < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Mn = x.ReactCurrentDispatcher, Cn;
    function Ht(c, m, b) {
      {
        if (Cn === void 0)
          try {
            throw Error();
          } catch (Y) {
            var E = Y.stack.trim().match(/\n( *(at )?)/);
            Cn = E && E[1] || "";
          }
        return `
` + Cn + c;
      }
    }
    var An = !1, Vt;
    {
      var ha = typeof WeakMap == "function" ? WeakMap : Map;
      Vt = new ha();
    }
    function Br(c, m) {
      if (!c || An)
        return "";
      {
        var b = Vt.get(c);
        if (b !== void 0)
          return b;
      }
      var E;
      An = !0;
      var Y = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var H;
      H = Mn.current, Mn.current = null, fa();
      try {
        if (m) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (se) {
              E = se;
            }
            Reflect.construct(c, [], C);
          } else {
            try {
              C.call();
            } catch (se) {
              E = se;
            }
            c.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (se) {
            E = se;
          }
          c();
        }
      } catch (se) {
        if (se && E && typeof se.stack == "string") {
          for (var N = se.stack.split(`
`), re = E.stack.split(`
`), G = N.length - 1, K = re.length - 1; G >= 1 && K >= 0 && N[G] !== re[K]; )
            K--;
          for (; G >= 1 && K >= 0; G--, K--)
            if (N[G] !== re[K]) {
              if (G !== 1 || K !== 1)
                do
                  if (G--, K--, K < 0 || N[G] !== re[K]) {
                    var le = `
` + N[G].replace(" at new ", " at ");
                    return c.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", c.displayName)), typeof c == "function" && Vt.set(c, le), le;
                  }
                while (G >= 1 && K >= 0);
              break;
            }
        }
      } finally {
        An = !1, Mn.current = H, da(), Error.prepareStackTrace = Y;
      }
      var Ze = c ? c.displayName || c.name : "", Ve = Ze ? Ht(Ze) : "";
      return typeof c == "function" && Vt.set(c, Ve), Ve;
    }
    function pa(c, m, b) {
      return Br(c, !1);
    }
    function ga(c) {
      var m = c.prototype;
      return !!(m && m.isReactComponent);
    }
    function Bt(c, m, b) {
      if (c == null)
        return "";
      if (typeof c == "function")
        return Br(c, ga(c));
      if (typeof c == "string")
        return Ht(c);
      switch (c) {
        case l:
          return Ht("Suspense");
        case f:
          return Ht("SuspenseList");
      }
      if (typeof c == "object")
        switch (c.$$typeof) {
          case u:
            return pa(c.render);
          case d:
            return Bt(c.type, m, b);
          case h: {
            var E = c, Y = E._payload, H = E._init;
            try {
              return Bt(H(Y), m, b);
            } catch {
            }
          }
        }
      return "";
    }
    var mt = Object.prototype.hasOwnProperty, zr = {}, Gr = x.ReactDebugCurrentFrame;
    function zt(c) {
      if (c) {
        var m = c._owner, b = Bt(c.type, c._source, m ? m.type : null);
        Gr.setExtraStackFrame(b);
      } else
        Gr.setExtraStackFrame(null);
    }
    function ma(c, m, b, E, Y) {
      {
        var H = Function.call.bind(mt);
        for (var C in c)
          if (H(c, C)) {
            var N = void 0;
            try {
              if (typeof c[C] != "function") {
                var re = Error((E || "React class") + ": " + b + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof c[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw re.name = "Invariant Violation", re;
              }
              N = c[C](m, C, E, b, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              N = G;
            }
            N && !(N instanceof Error) && (zt(Y), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", E || "React class", b, C, typeof N), zt(null)), N instanceof Error && !(N.message in zr) && (zr[N.message] = !0, zt(Y), k("Failed %s type: %s", b, N.message), zt(null));
          }
      }
    }
    var ya = Array.isArray;
    function Ln(c) {
      return ya(c);
    }
    function wa(c) {
      {
        var m = typeof Symbol == "function" && Symbol.toStringTag, b = m && c[Symbol.toStringTag] || c.constructor.name || "Object";
        return b;
      }
    }
    function Sa(c) {
      try {
        return qr(c), !1;
      } catch {
        return !0;
      }
    }
    function qr(c) {
      return "" + c;
    }
    function Kr(c) {
      if (Sa(c))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", wa(c)), qr(c);
    }
    var yt = x.ReactCurrentOwner, ba = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Jr, Zr, Fn;
    Fn = {};
    function va(c) {
      if (mt.call(c, "ref")) {
        var m = Object.getOwnPropertyDescriptor(c, "ref").get;
        if (m && m.isReactWarning)
          return !1;
      }
      return c.ref !== void 0;
    }
    function _a(c) {
      if (mt.call(c, "key")) {
        var m = Object.getOwnPropertyDescriptor(c, "key").get;
        if (m && m.isReactWarning)
          return !1;
      }
      return c.key !== void 0;
    }
    function Oa(c, m) {
      if (typeof c.ref == "string" && yt.current && m && yt.current.stateNode !== m) {
        var b = ue(yt.current.type);
        Fn[b] || (k('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', ue(yt.current.type), c.ref), Fn[b] = !0);
      }
    }
    function ka(c, m) {
      {
        var b = function() {
          Jr || (Jr = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", m));
        };
        b.isReactWarning = !0, Object.defineProperty(c, "key", {
          get: b,
          configurable: !0
        });
      }
    }
    function xa(c, m) {
      {
        var b = function() {
          Zr || (Zr = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", m));
        };
        b.isReactWarning = !0, Object.defineProperty(c, "ref", {
          get: b,
          configurable: !0
        });
      }
    }
    var Ra = function(c, m, b, E, Y, H, C) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: c,
        key: m,
        ref: b,
        props: C,
        // Record the component responsible for creating this element.
        _owner: H
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Y
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function Ea(c, m, b, E, Y) {
      {
        var H, C = {}, N = null, re = null;
        b !== void 0 && (Kr(b), N = "" + b), _a(m) && (Kr(m.key), N = "" + m.key), va(m) && (re = m.ref, Oa(m, Y));
        for (H in m)
          mt.call(m, H) && !ba.hasOwnProperty(H) && (C[H] = m[H]);
        if (c && c.defaultProps) {
          var G = c.defaultProps;
          for (H in G)
            C[H] === void 0 && (C[H] = G[H]);
        }
        if (N || re) {
          var K = typeof c == "function" ? c.displayName || c.name || "Unknown" : c;
          N && ka(C, K), re && xa(C, K);
        }
        return Ra(c, N, re, Y, E, yt.current, C);
      }
    }
    var In = x.ReactCurrentOwner, Qr = x.ReactDebugCurrentFrame;
    function Je(c) {
      if (c) {
        var m = c._owner, b = Bt(c.type, c._source, m ? m.type : null);
        Qr.setExtraStackFrame(b);
      } else
        Qr.setExtraStackFrame(null);
    }
    var Yn;
    Yn = !1;
    function Un(c) {
      return typeof c == "object" && c !== null && c.$$typeof === t;
    }
    function Xr() {
      {
        if (In.current) {
          var c = ue(In.current.type);
          if (c)
            return `

Check the render method of \`` + c + "`.";
        }
        return "";
      }
    }
    function Ta(c) {
      {
        if (c !== void 0) {
          var m = c.fileName.replace(/^.*[\\\/]/, ""), b = c.lineNumber;
          return `

Check your code at ` + m + ":" + b + ".";
        }
        return "";
      }
    }
    var es = {};
    function Da(c) {
      {
        var m = Xr();
        if (!m) {
          var b = typeof c == "string" ? c : c.displayName || c.name;
          b && (m = `

Check the top-level render call using <` + b + ">.");
        }
        return m;
      }
    }
    function ts(c, m) {
      {
        if (!c._store || c._store.validated || c.key != null)
          return;
        c._store.validated = !0;
        var b = Da(m);
        if (es[b])
          return;
        es[b] = !0;
        var E = "";
        c && c._owner && c._owner !== In.current && (E = " It was passed a child from " + ue(c._owner.type) + "."), Je(c), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', b, E), Je(null);
      }
    }
    function ns(c, m) {
      {
        if (typeof c != "object")
          return;
        if (Ln(c))
          for (var b = 0; b < c.length; b++) {
            var E = c[b];
            Un(E) && ts(E, m);
          }
        else if (Un(c))
          c._store && (c._store.validated = !0);
        else if (c) {
          var Y = _(c);
          if (typeof Y == "function" && Y !== c.entries)
            for (var H = Y.call(c), C; !(C = H.next()).done; )
              Un(C.value) && ts(C.value, m);
        }
      }
    }
    function Pa(c) {
      {
        var m = c.type;
        if (m == null || typeof m == "string")
          return;
        var b;
        if (typeof m == "function")
          b = m.propTypes;
        else if (typeof m == "object" && (m.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        m.$$typeof === d))
          b = m.propTypes;
        else
          return;
        if (b) {
          var E = ue(m);
          ma(b, c.props, "prop", E, c);
        } else if (m.PropTypes !== void 0 && !Yn) {
          Yn = !0;
          var Y = ue(m);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Y || "Unknown");
        }
        typeof m.getDefaultProps == "function" && !m.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Na(c) {
      {
        for (var m = Object.keys(c.props), b = 0; b < m.length; b++) {
          var E = m[b];
          if (E !== "children" && E !== "key") {
            Je(c), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", E), Je(null);
            break;
          }
        }
        c.ref !== null && (Je(c), k("Invalid attribute `ref` supplied to `React.Fragment`."), Je(null));
      }
    }
    var rs = {};
    function ss(c, m, b, E, Y, H) {
      {
        var C = Wt(c);
        if (!C) {
          var N = "";
          (c === void 0 || typeof c == "object" && c !== null && Object.keys(c).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var re = Ta(Y);
          re ? N += re : N += Xr();
          var G;
          c === null ? G = "null" : Ln(c) ? G = "array" : c !== void 0 && c.$$typeof === t ? (G = "<" + (ue(c.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : G = typeof c, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, N);
        }
        var K = Ea(c, m, b, Y, H);
        if (K == null)
          return K;
        if (C) {
          var le = m.children;
          if (le !== void 0)
            if (E)
              if (Ln(le)) {
                for (var Ze = 0; Ze < le.length; Ze++)
                  ns(le[Ze], c);
                Object.freeze && Object.freeze(le);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ns(le, c);
        }
        if (mt.call(m, "key")) {
          var Ve = ue(c), se = Object.keys(m).filter(function(Ia) {
            return Ia !== "key";
          }), jn = se.length > 0 ? "{key: someKey, " + se.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!rs[Ve + jn]) {
            var Fa = se.length > 0 ? "{" + se.join(": ..., ") + ": ...}" : "{}";
            k(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, jn, Ve, Fa, Ve), rs[Ve + jn] = !0;
          }
        }
        return c === r ? Na(K) : Pa(K), K;
      }
    }
    function Ma(c, m, b) {
      return ss(c, m, b, !0);
    }
    function Ca(c, m, b) {
      return ss(c, m, b, !1);
    }
    var Aa = Ca, La = Ma;
    St.Fragment = r, St.jsx = Aa, St.jsxs = La;
  }()), St;
}
process.env.NODE_ENV === "production" ? Xn.exports = Ha() : Xn.exports = Va();
var Ba = Xn.exports;
function za() {
  if (console && console.warn) {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    typeof t[0] == "string" && (t[0] = `react-i18next:: ${t[0]}`), console.warn(...t);
  }
}
const os = {};
function er() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  typeof t[0] == "string" && os[t[0]] || (typeof t[0] == "string" && (os[t[0]] = /* @__PURE__ */ new Date()), za(...t));
}
const Hs = (e, t) => () => {
  if (e.isInitialized)
    t();
  else {
    const n = () => {
      setTimeout(() => {
        e.off("initialized", n);
      }, 0), t();
    };
    e.on("initialized", n);
  }
};
function us(e, t, n) {
  e.loadNamespaces(t, Hs(e, n));
}
function ls(e, t, n, r) {
  typeof n == "string" && (n = [n]), n.forEach((s) => {
    e.options.ns.indexOf(s) < 0 && e.options.ns.push(s);
  }), e.loadLanguages(t, Hs(e, r));
}
function Ga(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const r = t.languages[0], s = t.options ? t.options.fallbackLng : !1, i = t.languages[t.languages.length - 1];
  if (r.toLowerCase() === "cimode")
    return !0;
  const a = (o, u) => {
    const l = t.services.backendConnector.state[`${o}|${u}`];
    return l === -1 || l === 2;
  };
  return n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !a(t.isLanguageChangingTo, e) ? !1 : !!(t.hasResourceBundle(r, e) || !t.services.backendConnector.backend || t.options.resources && !t.options.partialBundledLanguages || a(r, e) && (!s || a(i, e)));
}
function qa(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return !t.languages || !t.languages.length ? (er("i18n.languages were undefined or empty", t.languages), !0) : t.options.ignoreJSONStructure !== void 0 ? t.hasLoadedNamespace(e, {
    lng: n.lng,
    precheck: (s, i) => {
      if (n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && s.services.backendConnector.backend && s.isLanguageChangingTo && !i(s.isLanguageChangingTo, e))
        return !1;
    }
  }) : Ga(e, t, n);
}
const Ka = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Ja = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, Za = (e) => Ja[e], Qa = (e) => e.replace(Ka, Za);
let tr = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Qa
};
function Xa() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  tr = {
    ...tr,
    ...e
  };
}
function eo() {
  return tr;
}
let Vs;
function to(e) {
  Vs = e;
}
function no() {
  return Vs;
}
const ro = {
  type: "3rdParty",
  init(e) {
    Xa(e.options.react), to(e);
  }
}, Bs = Ya();
class so {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(t) {
    t.forEach((n) => {
      this.usedNamespaces[n] || (this.usedNamespaces[n] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const io = (e, t) => {
  const n = Zn();
  return Qn(() => {
    n.current = t ? n.current : e;
  }, [e, t]), n.current;
};
function ao(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    i18n: n
  } = t, {
    i18n: r,
    defaultNS: s
  } = Ua(Bs) || {}, i = n || r || no();
  if (i && !i.reportNamespaces && (i.reportNamespaces = new so()), !i) {
    er("You will need to pass in an i18next instance by using initReactI18next");
    const P = (U, $) => typeof $ == "string" ? $ : $ && typeof $ == "object" && typeof $.defaultValue == "string" ? $.defaultValue : Array.isArray(U) ? U[U.length - 1] : U, D = [P, {}, !1];
    return D.t = P, D.i18n = {}, D.ready = !1, D;
  }
  i.options.react && i.options.react.wait !== void 0 && er("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const a = {
    ...eo(),
    ...i.options.react,
    ...t
  }, {
    useSuspense: o,
    keyPrefix: u
  } = a;
  let l = e || s || i.options && i.options.defaultNS;
  l = typeof l == "string" ? [l] : l || ["translation"], i.reportNamespaces.addUsedNamespaces && i.reportNamespaces.addUsedNamespaces(l);
  const f = (i.isInitialized || i.initializedStoreOnce) && l.every((P) => qa(P, i, a));
  function d() {
    return i.getFixedT(t.lng || null, a.nsMode === "fallback" ? l : l[0], u);
  }
  const [h, S] = ja(d);
  let p = l.join();
  t.lng && (p = `${t.lng}${p}`);
  const y = io(p), _ = Zn(!0);
  Qn(() => {
    const {
      bindI18n: P,
      bindI18nStore: D
    } = a;
    _.current = !0, !f && !o && (t.lng ? ls(i, t.lng, l, () => {
      _.current && S(d);
    }) : us(i, l, () => {
      _.current && S(d);
    })), f && y && y !== p && _.current && S(d);
    function U() {
      _.current && S(d);
    }
    return P && i && i.on(P, U), D && i && i.store.on(D, U), () => {
      _.current = !1, P && i && P.split(" ").forEach(($) => i.off($, U)), D && i && D.split(" ").forEach(($) => i.store.off($, U));
    };
  }, [i, p]);
  const x = Zn(!0);
  Qn(() => {
    _.current && !x.current && S(d), x.current = !1;
  }, [i, u]);
  const k = [h, i, f];
  if (k.t = h, k.i18n = i, k.ready = f, f || !f && !o)
    return k;
  throw new Promise((P) => {
    t.lng ? ls(i, t.lng, l, () => P()) : us(i, l, () => P());
  });
}
function oo(e) {
  let {
    i18n: t,
    defaultNS: n,
    children: r
  } = e;
  const s = $a(() => ({
    i18n: t,
    defaultNS: n
  }), [t, n]);
  return Wa(Bs.Provider, {
    value: s
  }, r);
}
const uo = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console && console[e] && console[e].apply(console, t);
  }
};
class nn {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(t, n);
  }
  init(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = n.prefix || "i18next:", this.logger = t || uo, this.options = n, this.debug = n.debug;
  }
  log() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "log", "", !0);
  }
  warn() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "", !0);
  }
  error() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "error", "");
  }
  deprecate() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, n, r, s) {
    return s && !this.debug ? null : (typeof t[0] == "string" && (t[0] = `${r}${this.prefix} ${t[0]}`), this.logger[n](t));
  }
  create(t) {
    return new nn(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new nn(this.logger, t);
  }
}
var ve = new nn();
class hn {
  constructor() {
    this.observers = {};
  }
  on(t, n) {
    return t.split(" ").forEach((r) => {
      this.observers[r] || (this.observers[r] = /* @__PURE__ */ new Map());
      const s = this.observers[r].get(n) || 0;
      this.observers[r].set(n, s + 1);
    }), this;
  }
  off(t, n) {
    if (this.observers[t]) {
      if (!n) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(n);
    }
  }
  emit(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
      r[s - 1] = arguments[s];
    this.observers[t] && Array.from(this.observers[t].entries()).forEach((a) => {
      let [o, u] = a;
      for (let l = 0; l < u; l++)
        o(...r);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((a) => {
      let [o, u] = a;
      for (let l = 0; l < u; l++)
        o.apply(o, [t, ...r]);
    });
  }
}
function bt() {
  let e, t;
  const n = new Promise((r, s) => {
    e = r, t = s;
  });
  return n.resolve = e, n.reject = t, n;
}
function cs(e) {
  return e == null ? "" : "" + e;
}
function lo(e, t, n) {
  e.forEach((r) => {
    t[r] && (n[r] = t[r]);
  });
}
const co = /###/g;
function Rt(e, t, n) {
  function r(o) {
    return o && o.indexOf("###") > -1 ? o.replace(co, ".") : o;
  }
  function s() {
    return !e || typeof e == "string";
  }
  const i = typeof t != "string" ? t : t.split(".");
  let a = 0;
  for (; a < i.length - 1; ) {
    if (s())
      return {};
    const o = r(i[a]);
    !e[o] && n && (e[o] = new n()), Object.prototype.hasOwnProperty.call(e, o) ? e = e[o] : e = {}, ++a;
  }
  return s() ? {} : {
    obj: e,
    k: r(i[a])
  };
}
function fs(e, t, n) {
  const {
    obj: r,
    k: s
  } = Rt(e, t, Object);
  if (r !== void 0 || t.length === 1) {
    r[s] = n;
    return;
  }
  let i = t[t.length - 1], a = t.slice(0, t.length - 1), o = Rt(e, a, Object);
  for (; o.obj === void 0 && a.length; )
    i = `${a[a.length - 1]}.${i}`, a = a.slice(0, a.length - 1), o = Rt(e, a, Object), o && o.obj && typeof o.obj[`${o.k}.${i}`] < "u" && (o.obj = void 0);
  o.obj[`${o.k}.${i}`] = n;
}
function fo(e, t, n, r) {
  const {
    obj: s,
    k: i
  } = Rt(e, t, Object);
  s[i] = s[i] || [], r && (s[i] = s[i].concat(n)), r || s[i].push(n);
}
function rn(e, t) {
  const {
    obj: n,
    k: r
  } = Rt(e, t);
  if (n)
    return n[r];
}
function ho(e, t, n) {
  const r = rn(e, n);
  return r !== void 0 ? r : rn(t, n);
}
function zs(e, t, n) {
  for (const r in t)
    r !== "__proto__" && r !== "constructor" && (r in e ? typeof e[r] == "string" || e[r] instanceof String || typeof t[r] == "string" || t[r] instanceof String ? n && (e[r] = t[r]) : zs(e[r], t[r], n) : e[r] = t[r]);
  return e;
}
function Qe(e) {
  return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var po = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function go(e) {
  return typeof e == "string" ? e.replace(/[&<>"'\/]/g, (t) => po[t]) : e;
}
class mo {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const n = this.regExpMap.get(t);
    if (n !== void 0)
      return n;
    const r = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, r), this.regExpQueue.push(t), r;
  }
}
const yo = [" ", ",", "?", "!", ";"], wo = new mo(20);
function So(e, t, n) {
  t = t || "", n = n || "";
  const r = yo.filter((a) => t.indexOf(a) < 0 && n.indexOf(a) < 0);
  if (r.length === 0)
    return !0;
  const s = wo.getRegExp(`(${r.map((a) => a === "?" ? "\\?" : a).join("|")})`);
  let i = !s.test(e);
  if (!i) {
    const a = e.indexOf(n);
    a > 0 && !s.test(e.substring(0, a)) && (i = !0);
  }
  return i;
}
function nr(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!e)
    return;
  if (e[t])
    return e[t];
  const r = t.split(n);
  let s = e;
  for (let i = 0; i < r.length; ) {
    if (!s || typeof s != "object")
      return;
    let a, o = "";
    for (let u = i; u < r.length; ++u)
      if (u !== i && (o += n), o += r[u], a = s[o], a !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof a) > -1 && u < r.length - 1)
          continue;
        i += u - i + 1;
        break;
      }
    s = a;
  }
  return s;
}
function sn(e) {
  return e && e.indexOf("_") > 0 ? e.replace("_", "-") : e;
}
class ds extends hn {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = t || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const n = this.options.ns.indexOf(t);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(t, n, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator, a = s.ignoreJSONStructure !== void 0 ? s.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let o;
    t.indexOf(".") > -1 ? o = t.split(".") : (o = [t, n], r && (Array.isArray(r) ? o.push(...r) : typeof r == "string" && i ? o.push(...r.split(i)) : o.push(r)));
    const u = rn(this.data, o);
    return !u && !n && !r && t.indexOf(".") > -1 && (t = o[0], n = o[1], r = o.slice(2).join(".")), u || !a || typeof r != "string" ? u : nr(this.data && this.data[t] && this.data[t][n], r, i);
  }
  addResource(t, n, r, s) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const a = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let o = [t, n];
    r && (o = o.concat(a ? r.split(a) : r)), t.indexOf(".") > -1 && (o = t.split("."), s = n, n = o[1]), this.addNamespaces(n), fs(this.data, o, s), i.silent || this.emit("added", t, n, r, s);
  }
  addResources(t, n, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const i in r)
      (typeof r[i] == "string" || Object.prototype.toString.apply(r[i]) === "[object Array]") && this.addResource(t, n, i, r[i], {
        silent: !0
      });
    s.silent || this.emit("added", t, n, r);
  }
  addResourceBundle(t, n, r, s, i) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, o = [t, n];
    t.indexOf(".") > -1 && (o = t.split("."), s = r, r = n, n = o[1]), this.addNamespaces(n);
    let u = rn(this.data, o) || {};
    a.skipCopy || (r = JSON.parse(JSON.stringify(r))), s ? zs(u, r, i) : u = {
      ...u,
      ...r
    }, fs(this.data, o, u), a.silent || this.emit("added", t, n, r);
  }
  removeResourceBundle(t, n) {
    this.hasResourceBundle(t, n) && delete this.data[t][n], this.removeNamespaces(n), this.emit("removed", t, n);
  }
  hasResourceBundle(t, n) {
    return this.getResource(t, n) !== void 0;
  }
  getResourceBundle(t, n) {
    return n || (n = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(t, n)
    } : this.getResource(t, n);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const n = this.getDataByLanguage(t);
    return !!(n && Object.keys(n) || []).find((s) => n[s] && Object.keys(n[s]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Gs = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, n, r, s) {
    return e.forEach((i) => {
      this.processors[i] && (t = this.processors[i].process(t, n, r, s));
    }), t;
  }
};
const hs = {};
class an extends hn {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), lo(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = ve.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (t == null)
      return !1;
    const r = this.resolve(t, n);
    return r && r.res !== void 0;
  }
  extractFromKey(t, n) {
    let r = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const s = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let i = n.ns || this.options.defaultNS || [];
    const a = r && t.indexOf(r) > -1, o = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !So(t, r, s);
    if (a && !o) {
      const u = t.match(this.interpolator.nestingRegexp);
      if (u && u.length > 0)
        return {
          key: t,
          namespaces: i
        };
      const l = t.split(r);
      (r !== s || r === s && this.options.ns.indexOf(l[0]) > -1) && (i = l.shift()), t = l.join(s);
    }
    return typeof i == "string" && (i = [i]), {
      key: t,
      namespaces: i
    };
  }
  translate(t, n, r) {
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
      ...n
    }), n || (n = {}), t == null)
      return "";
    Array.isArray(t) || (t = [String(t)]);
    const s = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: a,
      namespaces: o
    } = this.extractFromKey(t[t.length - 1], n), u = o[o.length - 1], l = n.lng || this.language, f = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (l && l.toLowerCase() === "cimode") {
      if (f) {
        const D = n.nsSeparator || this.options.nsSeparator;
        return s ? {
          res: `${u}${D}${a}`,
          usedKey: a,
          exactUsedKey: a,
          usedLng: l,
          usedNS: u,
          usedParams: this.getUsedParamsDetails(n)
        } : `${u}${D}${a}`;
      }
      return s ? {
        res: a,
        usedKey: a,
        exactUsedKey: a,
        usedLng: l,
        usedNS: u,
        usedParams: this.getUsedParamsDetails(n)
      } : a;
    }
    const d = this.resolve(t, n);
    let h = d && d.res;
    const S = d && d.usedKey || a, p = d && d.exactUsedKey || a, y = Object.prototype.toString.apply(h), _ = ["[object Number]", "[object Function]", "[object RegExp]"], x = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, k = !this.i18nFormat || this.i18nFormat.handleAsObject;
    if (k && h && (typeof h != "string" && typeof h != "boolean" && typeof h != "number") && _.indexOf(y) < 0 && !(typeof x == "string" && y === "[object Array]")) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const D = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(S, h, {
          ...n,
          ns: o
        }) : `key '${a} (${this.language})' returned an object instead of string.`;
        return s ? (d.res = D, d.usedParams = this.getUsedParamsDetails(n), d) : D;
      }
      if (i) {
        const D = y === "[object Array]", U = D ? [] : {}, $ = D ? p : S;
        for (const W in h)
          if (Object.prototype.hasOwnProperty.call(h, W)) {
            const Ke = `${$}${i}${W}`;
            U[W] = this.translate(Ke, {
              ...n,
              joinArrays: !1,
              ns: o
            }), U[W] === Ke && (U[W] = h[W]);
          }
        h = U;
      }
    } else if (k && typeof x == "string" && y === "[object Array]")
      h = h.join(x), h && (h = this.extendTranslation(h, t, n, r));
    else {
      let D = !1, U = !1;
      const $ = n.count !== void 0 && typeof n.count != "string", W = an.hasDefaultValue(n), Ke = $ ? this.pluralResolver.getSuffix(l, n.count, n) : "", $t = n.ordinal && $ ? this.pluralResolver.getSuffix(l, n.count, {
        ordinal: !1
      }) : "", Wt = $ && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), We = Wt && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${Ke}`] || n[`defaultValue${$t}`] || n.defaultValue;
      !this.isValidLookup(h) && W && (D = !0, h = We), this.isValidLookup(h) || (U = !0, h = a);
      const ue = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && U ? void 0 : h, ae = W && We !== h && this.options.updateMissing;
      if (U || D || ae) {
        if (this.logger.log(ae ? "updateKey" : "missingKey", l, u, a, ae ? We : h), i) {
          const X = this.resolve(a, {
            ...n,
            keySeparator: !1
          });
          X && X.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let pe = [];
        const He = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && He && He[0])
          for (let X = 0; X < He.length; X++)
            pe.push(He[X]);
        else
          this.options.saveMissingTo === "all" ? pe = this.languageUtils.toResolveHierarchy(n.lng || this.language) : pe.push(n.lng || this.language);
        const pt = (X, Se, Ie) => {
          const gt = W && Ie !== h ? Ie : ue;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(X, u, Se, gt, ae, n) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(X, u, Se, gt, ae, n), this.emit("missingKey", X, u, Se, h);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && $ ? pe.forEach((X) => {
          const Se = this.pluralResolver.getSuffixes(X, n);
          Wt && n[`defaultValue${this.options.pluralSeparator}zero`] && Se.indexOf(`${this.options.pluralSeparator}zero`) < 0 && Se.push(`${this.options.pluralSeparator}zero`), Se.forEach((Ie) => {
            pt([X], a + Ie, n[`defaultValue${Ie}`] || We);
          });
        }) : pt(pe, a, We));
      }
      h = this.extendTranslation(h, t, n, d, r), U && h === a && this.options.appendNamespaceToMissingKey && (h = `${u}:${a}`), (U || D) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? h = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${u}:${a}` : a, D ? h : void 0) : h = this.options.parseMissingKeyHandler(h));
    }
    return s ? (d.res = h, d.usedParams = this.getUsedParamsDetails(n), d) : h;
  }
  extendTranslation(t, n, r, s, i) {
    var a = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...r
      }, r.lng || this.language || s.usedLng, s.usedNS, s.usedKey, {
        resolved: s
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init({
        ...r,
        interpolation: {
          ...this.options.interpolation,
          ...r.interpolation
        }
      });
      const l = typeof t == "string" && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let f;
      if (l) {
        const h = t.match(this.interpolator.nestingRegexp);
        f = h && h.length;
      }
      let d = r.replace && typeof r.replace != "string" ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (d = {
        ...this.options.interpolation.defaultVariables,
        ...d
      }), t = this.interpolator.interpolate(t, d, r.lng || this.language, r), l) {
        const h = t.match(this.interpolator.nestingRegexp), S = h && h.length;
        f < S && (r.nest = !1);
      }
      !r.lng && this.options.compatibilityAPI !== "v1" && s && s.res && (r.lng = s.usedLng), r.nest !== !1 && (t = this.interpolator.nest(t, function() {
        for (var h = arguments.length, S = new Array(h), p = 0; p < h; p++)
          S[p] = arguments[p];
        return i && i[0] === S[0] && !r.context ? (a.logger.warn(`It seems you are nesting recursively key: ${S[0]} in key: ${n[0]}`), null) : a.translate(...S, n);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const o = r.postProcess || this.options.postProcess, u = typeof o == "string" ? [o] : o;
    return t != null && u && u.length && r.applyPostProcessor !== !1 && (t = Gs.handle(u, t, n, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...s,
        usedParams: this.getUsedParamsDetails(r)
      },
      ...r
    } : r, this)), t;
  }
  resolve(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, s, i, a, o;
    return typeof t == "string" && (t = [t]), t.forEach((u) => {
      if (this.isValidLookup(r))
        return;
      const l = this.extractFromKey(u, n), f = l.key;
      s = f;
      let d = l.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const h = n.count !== void 0 && typeof n.count != "string", S = h && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), p = n.context !== void 0 && (typeof n.context == "string" || typeof n.context == "number") && n.context !== "", y = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      d.forEach((_) => {
        this.isValidLookup(r) || (o = _, !hs[`${y[0]}-${_}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(o) && (hs[`${y[0]}-${_}`] = !0, this.logger.warn(`key "${s}" for languages "${y.join(", ")}" won't get resolved as namespace "${o}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), y.forEach((x) => {
          if (this.isValidLookup(r))
            return;
          a = x;
          const k = [f];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(k, f, x, _, n);
          else {
            let D;
            h && (D = this.pluralResolver.getSuffix(x, n.count, n));
            const U = `${this.options.pluralSeparator}zero`, $ = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (h && (k.push(f + D), n.ordinal && D.indexOf($) === 0 && k.push(f + D.replace($, this.options.pluralSeparator)), S && k.push(f + U)), p) {
              const W = `${f}${this.options.contextSeparator}${n.context}`;
              k.push(W), h && (k.push(W + D), n.ordinal && D.indexOf($) === 0 && k.push(W + D.replace($, this.options.pluralSeparator)), S && k.push(W + U));
            }
          }
          let P;
          for (; P = k.pop(); )
            this.isValidLookup(r) || (i = P, r = this.getResource(x, _, P, n));
        }));
      });
    }), {
      res: r,
      usedKey: s,
      exactUsedKey: i,
      usedLng: a,
      usedNS: o
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, n, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(t, n, r, s) : this.resourceStore.getResource(t, n, r, s);
  }
  getUsedParamsDetails() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = t.replace && typeof t.replace != "string";
    let s = r ? t.replace : t;
    if (r && typeof t.count < "u" && (s.count = t.count), this.options.interpolation.defaultVariables && (s = {
      ...this.options.interpolation.defaultVariables,
      ...s
    }), !r) {
      s = {
        ...s
      };
      for (const i of n)
        delete s[i];
    }
    return s;
  }
  static hasDefaultValue(t) {
    const n = "defaultValue";
    for (const r in t)
      if (Object.prototype.hasOwnProperty.call(t, r) && n === r.substring(0, n.length) && t[r] !== void 0)
        return !0;
    return !1;
  }
}
function $n(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
class ps {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = ve.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = sn(t), !t || t.indexOf("-") < 0)
      return null;
    const n = t.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = sn(t), !t || t.indexOf("-") < 0)
      return t;
    const n = t.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(t) {
    if (typeof t == "string" && t.indexOf("-") > -1) {
      const n = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let r = t.split("-");
      return this.options.lowerCaseLng ? r = r.map((s) => s.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = $n(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = $n(r[1].toLowerCase())), n.indexOf(r[2].toLowerCase()) > -1 && (r[2] = $n(r[2].toLowerCase()))), r.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t)
      return null;
    let n;
    return t.forEach((r) => {
      if (n)
        return;
      const s = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(s)) && (n = s);
    }), !n && this.options.supportedLngs && t.forEach((r) => {
      if (n)
        return;
      const s = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(s))
        return n = s;
      n = this.options.supportedLngs.find((i) => {
        if (i === s)
          return i;
        if (!(i.indexOf("-") < 0 && s.indexOf("-") < 0) && (i.indexOf("-") > 0 && s.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === s || i.indexOf(s) === 0 && s.length > 1))
          return i;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(t, n) {
    if (!t)
      return [];
    if (typeof t == "function" && (t = t(n)), typeof t == "string" && (t = [t]), Object.prototype.toString.apply(t) === "[object Array]")
      return t;
    if (!n)
      return t.default || [];
    let r = t[n];
    return r || (r = t[this.getScriptPartFromCode(n)]), r || (r = t[this.formatLanguageCode(n)]), r || (r = t[this.getLanguagePartFromCode(n)]), r || (r = t.default), r || [];
  }
  toResolveHierarchy(t, n) {
    const r = this.getFallbackCodes(n || this.options.fallbackLng || [], t), s = [], i = (a) => {
      a && (this.isSupportedCode(a) ? s.push(a) : this.logger.warn(`rejecting language code not found in supportedLngs: ${a}`));
    };
    return typeof t == "string" && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(t))) : typeof t == "string" && i(this.formatLanguageCode(t)), r.forEach((a) => {
      s.indexOf(a) < 0 && i(this.formatLanguageCode(a));
    }), s;
  }
}
let bo = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], vo = {
  1: function(e) {
    return +(e > 1);
  },
  2: function(e) {
    return +(e != 1);
  },
  3: function(e) {
    return 0;
  },
  4: function(e) {
    return e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2;
  },
  5: function(e) {
    return e == 0 ? 0 : e == 1 ? 1 : e == 2 ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5;
  },
  6: function(e) {
    return e == 1 ? 0 : e >= 2 && e <= 4 ? 1 : 2;
  },
  7: function(e) {
    return e == 1 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2;
  },
  8: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : e != 8 && e != 11 ? 2 : 3;
  },
  9: function(e) {
    return +(e >= 2);
  },
  10: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4;
  },
  11: function(e) {
    return e == 1 || e == 11 ? 0 : e == 2 || e == 12 ? 1 : e > 2 && e < 20 ? 2 : 3;
  },
  12: function(e) {
    return +(e % 10 != 1 || e % 100 == 11);
  },
  13: function(e) {
    return +(e !== 0);
  },
  14: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : e == 3 ? 2 : 3;
  },
  15: function(e) {
    return e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2;
  },
  16: function(e) {
    return e % 10 == 1 && e % 100 != 11 ? 0 : e !== 0 ? 1 : 2;
  },
  17: function(e) {
    return e == 1 || e % 10 == 1 && e % 100 != 11 ? 0 : 1;
  },
  18: function(e) {
    return e == 0 ? 0 : e == 1 ? 1 : 2;
  },
  19: function(e) {
    return e == 1 ? 0 : e == 0 || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3;
  },
  20: function(e) {
    return e == 1 ? 0 : e == 0 || e % 100 > 0 && e % 100 < 20 ? 1 : 2;
  },
  21: function(e) {
    return e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0;
  },
  22: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3;
  }
};
const _o = ["v1", "v2", "v3"], Oo = ["v4"], gs = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function ko() {
  const e = {};
  return bo.forEach((t) => {
    t.lngs.forEach((n) => {
      e[n] = {
        numbers: t.nr,
        plurals: vo[t.fc]
      };
    });
  }), e;
}
class xo {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = t, this.options = n, this.logger = ve.create("pluralResolver"), (!this.options.compatibilityJSON || Oo.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = ko();
  }
  addRule(t, n) {
    this.rules[t] = n;
  }
  getRule(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi())
      try {
        return new Intl.PluralRules(sn(t === "dev" ? "en" : t), {
          type: n.ordinal ? "ordinal" : "cardinal"
        });
      } catch {
        return;
      }
    return this.rules[t] || this.rules[this.languageUtils.getLanguagePartFromCode(t)];
  }
  needsPlural(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
  }
  getPluralFormsOfKey(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(t, r).map((s) => `${n}${s}`);
  }
  getSuffixes(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((s, i) => gs[s] - gs[i]).map((s) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${s}`) : r.numbers.map((s) => this.getSuffix(t, s, n)) : [];
  }
  getSuffix(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const s = this.getRule(t, r);
    return s ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${s.select(n)}` : this.getSuffixRetroCompatible(s, n) : (this.logger.warn(`no plural rule found for: ${t}`), "");
  }
  getSuffixRetroCompatible(t, n) {
    const r = t.noAbs ? t.plurals(n) : t.plurals(Math.abs(n));
    let s = t.numbers[r];
    this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 && (s === 2 ? s = "plural" : s === 1 && (s = ""));
    const i = () => this.options.prepend && s.toString() ? this.options.prepend + s.toString() : s.toString();
    return this.options.compatibilityJSON === "v1" ? s === 1 ? "" : typeof s == "number" ? `_plural_${s.toString()}` : i() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 ? i() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
  }
  shouldUseIntlApi() {
    return !_o.includes(this.options.compatibilityJSON);
  }
}
function ms(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = ho(e, t, n);
  return !i && s && typeof n == "string" && (i = nr(e, n, r), i === void 0 && (i = nr(t, n, r))), i;
}
class Ro {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = ve.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || ((n) => n), this.init(t);
  }
  init() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const n = t.interpolation;
    this.escape = n.escape !== void 0 ? n.escape : go, this.escapeValue = n.escapeValue !== void 0 ? n.escapeValue : !0, this.useRawValueToEscape = n.useRawValueToEscape !== void 0 ? n.useRawValueToEscape : !1, this.prefix = n.prefix ? Qe(n.prefix) : n.prefixEscaped || "{{", this.suffix = n.suffix ? Qe(n.suffix) : n.suffixEscaped || "}}", this.formatSeparator = n.formatSeparator ? n.formatSeparator : n.formatSeparator || ",", this.unescapePrefix = n.unescapeSuffix ? "" : n.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : n.unescapeSuffix || "", this.nestingPrefix = n.nestingPrefix ? Qe(n.nestingPrefix) : n.nestingPrefixEscaped || Qe("$t("), this.nestingSuffix = n.nestingSuffix ? Qe(n.nestingSuffix) : n.nestingSuffixEscaped || Qe(")"), this.nestingOptionsSeparator = n.nestingOptionsSeparator ? n.nestingOptionsSeparator : n.nestingOptionsSeparator || ",", this.maxReplaces = n.maxReplaces ? n.maxReplaces : 1e3, this.alwaysFormat = n.alwaysFormat !== void 0 ? n.alwaysFormat : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (n, r) => n && n.source === r ? (n.lastIndex = 0, n) : new RegExp(r, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(t, n, r, s) {
    let i, a, o;
    const u = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
    function l(p) {
      return p.replace(/\$/g, "$$$$");
    }
    const f = (p) => {
      if (p.indexOf(this.formatSeparator) < 0) {
        const k = ms(n, u, p, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(k, void 0, r, {
          ...s,
          ...n,
          interpolationkey: p
        }) : k;
      }
      const y = p.split(this.formatSeparator), _ = y.shift().trim(), x = y.join(this.formatSeparator).trim();
      return this.format(ms(n, u, _, this.options.keySeparator, this.options.ignoreJSONStructure), x, r, {
        ...s,
        ...n,
        interpolationkey: _
      });
    };
    this.resetRegExp();
    const d = s && s.missingInterpolationHandler || this.options.missingInterpolationHandler, h = s && s.interpolation && s.interpolation.skipOnVariables !== void 0 ? s.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (p) => l(p)
    }, {
      regex: this.regexp,
      safeValue: (p) => this.escapeValue ? l(this.escape(p)) : l(p)
    }].forEach((p) => {
      for (o = 0; i = p.regex.exec(t); ) {
        const y = i[1].trim();
        if (a = f(y), a === void 0)
          if (typeof d == "function") {
            const x = d(t, i, s);
            a = typeof x == "string" ? x : "";
          } else if (s && Object.prototype.hasOwnProperty.call(s, y))
            a = "";
          else if (h) {
            a = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${y} for interpolating ${t}`), a = "";
        else
          typeof a != "string" && !this.useRawValueToEscape && (a = cs(a));
        const _ = p.safeValue(a);
        if (t = t.replace(i[0], _), h ? (p.regex.lastIndex += a.length, p.regex.lastIndex -= i[0].length) : p.regex.lastIndex = 0, o++, o >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s, i, a;
    function o(u, l) {
      const f = this.nestingOptionsSeparator;
      if (u.indexOf(f) < 0)
        return u;
      const d = u.split(new RegExp(`${f}[ ]*{`));
      let h = `{${d[1]}`;
      u = d[0], h = this.interpolate(h, a);
      const S = h.match(/'/g), p = h.match(/"/g);
      (S && S.length % 2 === 0 && !p || p.length % 2 !== 0) && (h = h.replace(/'/g, '"'));
      try {
        a = JSON.parse(h), l && (a = {
          ...l,
          ...a
        });
      } catch (y) {
        return this.logger.warn(`failed parsing options string in nesting for key ${u}`, y), `${u}${f}${h}`;
      }
      return delete a.defaultValue, u;
    }
    for (; s = this.nestingRegexp.exec(t); ) {
      let u = [];
      a = {
        ...r
      }, a = a.replace && typeof a.replace != "string" ? a.replace : a, a.applyPostProcessor = !1, delete a.defaultValue;
      let l = !1;
      if (s[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(s[1])) {
        const f = s[1].split(this.formatSeparator).map((d) => d.trim());
        s[1] = f.shift(), u = f, l = !0;
      }
      if (i = n(o.call(this, s[1].trim(), a), a), i && s[0] === t && typeof i != "string")
        return i;
      typeof i != "string" && (i = cs(i)), i || (this.logger.warn(`missed to resolve ${s[1]} for nesting ${t}`), i = ""), l && (i = u.reduce((f, d) => this.format(f, d, r.lng, {
        ...r,
        interpolationkey: s[1].trim()
      }), i.trim())), t = t.replace(s[0], i), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
function Eo(e) {
  let t = e.toLowerCase().trim();
  const n = {};
  if (e.indexOf("(") > -1) {
    const r = e.split("(");
    t = r[0].toLowerCase().trim();
    const s = r[1].substring(0, r[1].length - 1);
    t === "currency" && s.indexOf(":") < 0 ? n.currency || (n.currency = s.trim()) : t === "relativetime" && s.indexOf(":") < 0 ? n.range || (n.range = s.trim()) : s.split(";").forEach((a) => {
      if (!a)
        return;
      const [o, ...u] = a.split(":"), l = u.join(":").trim().replace(/^'+|'+$/g, "");
      n[o.trim()] || (n[o.trim()] = l), l === "false" && (n[o.trim()] = !1), l === "true" && (n[o.trim()] = !0), isNaN(l) || (n[o.trim()] = parseInt(l, 10));
    });
  }
  return {
    formatName: t,
    formatOptions: n
  };
}
function Xe(e) {
  const t = {};
  return function(r, s, i) {
    const a = s + JSON.stringify(i);
    let o = t[a];
    return o || (o = e(sn(s), i), t[a] = o), o(r);
  };
}
class To {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = ve.create("formatter"), this.options = t, this.formats = {
      number: Xe((n, r) => {
        const s = new Intl.NumberFormat(n, {
          ...r
        });
        return (i) => s.format(i);
      }),
      currency: Xe((n, r) => {
        const s = new Intl.NumberFormat(n, {
          ...r,
          style: "currency"
        });
        return (i) => s.format(i);
      }),
      datetime: Xe((n, r) => {
        const s = new Intl.DateTimeFormat(n, {
          ...r
        });
        return (i) => s.format(i);
      }),
      relativetime: Xe((n, r) => {
        const s = new Intl.RelativeTimeFormat(n, {
          ...r
        });
        return (i) => s.format(i, r.range || "day");
      }),
      list: Xe((n, r) => {
        const s = new Intl.ListFormat(n, {
          ...r
        });
        return (i) => s.format(i);
      })
    }, this.init(t);
  }
  init(t) {
    const r = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    }).interpolation;
    this.formatSeparator = r.formatSeparator ? r.formatSeparator : r.formatSeparator || ",";
  }
  add(t, n) {
    this.formats[t.toLowerCase().trim()] = n;
  }
  addCached(t, n) {
    this.formats[t.toLowerCase().trim()] = Xe(n);
  }
  format(t, n, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return n.split(this.formatSeparator).reduce((o, u) => {
      const {
        formatName: l,
        formatOptions: f
      } = Eo(u);
      if (this.formats[l]) {
        let d = o;
        try {
          const h = s && s.formatParams && s.formatParams[s.interpolationkey] || {}, S = h.locale || h.lng || s.locale || s.lng || r;
          d = this.formats[l](o, S, {
            ...f,
            ...s,
            ...h
          });
        } catch (h) {
          this.logger.warn(h);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${l}`);
      return o;
    }, t);
  }
}
function Do(e, t) {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
}
class Po extends hn {
  constructor(t, n, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = t, this.store = n, this.services = r, this.languageUtils = r.languageUtils, this.options = s, this.logger = ve.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = s.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = s.maxRetries >= 0 ? s.maxRetries : 5, this.retryTimeout = s.retryTimeout >= 1 ? s.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, s.backend, s);
  }
  queueLoad(t, n, r, s) {
    const i = {}, a = {}, o = {}, u = {};
    return t.forEach((l) => {
      let f = !0;
      n.forEach((d) => {
        const h = `${l}|${d}`;
        !r.reload && this.store.hasResourceBundle(l, d) ? this.state[h] = 2 : this.state[h] < 0 || (this.state[h] === 1 ? a[h] === void 0 && (a[h] = !0) : (this.state[h] = 1, f = !1, a[h] === void 0 && (a[h] = !0), i[h] === void 0 && (i[h] = !0), u[d] === void 0 && (u[d] = !0)));
      }), f || (o[l] = !0);
    }), (Object.keys(i).length || Object.keys(a).length) && this.queue.push({
      pending: a,
      pendingCount: Object.keys(a).length,
      loaded: {},
      errors: [],
      callback: s
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(a),
      toLoadLanguages: Object.keys(o),
      toLoadNamespaces: Object.keys(u)
    };
  }
  loaded(t, n, r) {
    const s = t.split("|"), i = s[0], a = s[1];
    n && this.emit("failedLoading", i, a, n), r && this.store.addResourceBundle(i, a, r, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = n ? -1 : 2;
    const o = {};
    this.queue.forEach((u) => {
      fo(u.loaded, [i], a), Do(u, t), n && u.errors.push(n), u.pendingCount === 0 && !u.done && (Object.keys(u.loaded).forEach((l) => {
        o[l] || (o[l] = {});
        const f = u.loaded[l];
        f.length && f.forEach((d) => {
          o[l][d] === void 0 && (o[l][d] = !0);
        });
      }), u.done = !0, u.errors.length ? u.callback(u.errors) : u.callback());
    }), this.emit("loaded", o), this.queue = this.queue.filter((u) => !u.done);
  }
  read(t, n, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, a = arguments.length > 5 ? arguments[5] : void 0;
    if (!t.length)
      return a(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: n,
        fcName: r,
        tried: s,
        wait: i,
        callback: a
      });
      return;
    }
    this.readingCalls++;
    const o = (l, f) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (l && f && s < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, n, r, s + 1, i * 2, a);
        }, i);
        return;
      }
      a(l, f);
    }, u = this.backend[r].bind(this.backend);
    if (u.length === 2) {
      try {
        const l = u(t, n);
        l && typeof l.then == "function" ? l.then((f) => o(null, f)).catch(o) : o(null, l);
      } catch (l) {
        o(l);
      }
      return;
    }
    return u(t, n, o);
  }
  prepareLoading(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), s && s();
    typeof t == "string" && (t = this.languageUtils.toResolveHierarchy(t)), typeof n == "string" && (n = [n]);
    const i = this.queueLoad(t, n, r, s);
    if (!i.toLoad.length)
      return i.pending.length || s(), null;
    i.toLoad.forEach((a) => {
      this.loadOne(a);
    });
  }
  load(t, n, r) {
    this.prepareLoading(t, n, {}, r);
  }
  reload(t, n, r) {
    this.prepareLoading(t, n, {
      reload: !0
    }, r);
  }
  loadOne(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = t.split("|"), s = r[0], i = r[1];
    this.read(s, i, "read", void 0, void 0, (a, o) => {
      a && this.logger.warn(`${n}loading namespace ${i} for language ${s} failed`, a), !a && o && this.logger.log(`${n}loaded namespace ${i} for language ${s}`, o), this.loaded(t, a, o);
    });
  }
  saveMissing(t, n, r, s, i) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend && this.backend.create) {
        const u = {
          ...a,
          isUpdate: i
        }, l = this.backend.create.bind(this.backend);
        if (l.length < 6)
          try {
            let f;
            l.length === 5 ? f = l(t, n, r, s, u) : f = l(t, n, r, s), f && typeof f.then == "function" ? f.then((d) => o(null, d)).catch(o) : o(null, f);
          } catch (f) {
            o(f);
          }
        else
          l(t, n, r, s, o, u);
      }
      !t || !t[0] || this.store.addResource(t[0], n, r, s);
    }
  }
}
function ys() {
  return {
    debug: !1,
    initImmediate: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !1,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: function(t) {
      let n = {};
      if (typeof t[1] == "object" && (n = t[1]), typeof t[1] == "string" && (n.defaultValue = t[1]), typeof t[2] == "string" && (n.tDescription = t[2]), typeof t[2] == "object" || typeof t[3] == "object") {
        const r = t[3] || t[2];
        Object.keys(r).forEach((s) => {
          n[s] = r[s];
        });
      }
      return n;
    },
    interpolation: {
      escapeValue: !0,
      format: (e) => e,
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: !0
    }
  };
}
function ws(e) {
  return typeof e.ns == "string" && (e.ns = [e.ns]), typeof e.fallbackLng == "string" && (e.fallbackLng = [e.fallbackLng]), typeof e.fallbackNS == "string" && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e;
}
function Gt() {
}
function No(e) {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((n) => {
    typeof e[n] == "function" && (e[n] = e[n].bind(e));
  });
}
class Tt extends hn {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = ws(t), this.services = {}, this.logger = ve, this.modules = {
      external: []
    }, No(this), n && !this.isInitialized && !t.isClone) {
      if (!this.options.initImmediate)
        return this.init(t, n), this;
      setTimeout(() => {
        this.init(t, n);
      }, 0);
    }
  }
  init() {
    var t = this;
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof n == "function" && (r = n, n = {}), !n.defaultNS && n.defaultNS !== !1 && n.ns && (typeof n.ns == "string" ? n.defaultNS = n.ns : n.ns.indexOf("translation") < 0 && (n.defaultNS = n.ns[0]));
    const s = ys();
    this.options = {
      ...s,
      ...this.options,
      ...ws(n)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...s.interpolation,
      ...this.options.interpolation
    }), n.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = n.keySeparator), n.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = n.nsSeparator);
    function i(f) {
      return f ? typeof f == "function" ? new f() : f : null;
    }
    if (!this.options.isClone) {
      this.modules.logger ? ve.init(i(this.modules.logger), this.options) : ve.init(null, this.options);
      let f;
      this.modules.formatter ? f = this.modules.formatter : typeof Intl < "u" && (f = To);
      const d = new ps(this.options);
      this.store = new ds(this.options.resources, this.options);
      const h = this.services;
      h.logger = ve, h.resourceStore = this.store, h.languageUtils = d, h.pluralResolver = new xo(d, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), f && (!this.options.interpolation.format || this.options.interpolation.format === s.interpolation.format) && (h.formatter = i(f), h.formatter.init(h, this.options), this.options.interpolation.format = h.formatter.format.bind(h.formatter)), h.interpolator = new Ro(this.options), h.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, h.backendConnector = new Po(i(this.modules.backend), h.resourceStore, h, this.options), h.backendConnector.on("*", function(S) {
        for (var p = arguments.length, y = new Array(p > 1 ? p - 1 : 0), _ = 1; _ < p; _++)
          y[_ - 1] = arguments[_];
        t.emit(S, ...y);
      }), this.modules.languageDetector && (h.languageDetector = i(this.modules.languageDetector), h.languageDetector.init && h.languageDetector.init(h, this.options.detection, this.options)), this.modules.i18nFormat && (h.i18nFormat = i(this.modules.i18nFormat), h.i18nFormat.init && h.i18nFormat.init(this)), this.translator = new an(this.services, this.options), this.translator.on("*", function(S) {
        for (var p = arguments.length, y = new Array(p > 1 ? p - 1 : 0), _ = 1; _ < p; _++)
          y[_ - 1] = arguments[_];
        t.emit(S, ...y);
      }), this.modules.external.forEach((S) => {
        S.init && S.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = Gt), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const f = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      f.length > 0 && f[0] !== "dev" && (this.options.lng = f[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((f) => {
      this[f] = function() {
        return t.store[f](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((f) => {
      this[f] = function() {
        return t.store[f](...arguments), t;
      };
    });
    const u = bt(), l = () => {
      const f = (d, h) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), u.resolve(h), r(d, h);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return f(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, f);
    };
    return this.options.resources || !this.options.initImmediate ? l() : setTimeout(l, 0), u;
  }
  loadResources(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Gt;
    const s = typeof t == "string" ? t : this.language;
    if (typeof t == "function" && (r = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (s && s.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return r();
      const i = [], a = (o) => {
        if (!o || o === "cimode")
          return;
        this.services.languageUtils.toResolveHierarchy(o).forEach((l) => {
          l !== "cimode" && i.indexOf(l) < 0 && i.push(l);
        });
      };
      s ? a(s) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((u) => a(u)), this.options.preload && this.options.preload.forEach((o) => a(o)), this.services.backendConnector.load(i, this.options.ns, (o) => {
        !o && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), r(o);
      });
    } else
      r(null);
  }
  reloadResources(t, n, r) {
    const s = bt();
    return t || (t = this.languages), n || (n = this.options.ns), r || (r = Gt), this.services.backendConnector.reload(t, n, (i) => {
      s.resolve(), r(i);
    }), s;
  }
  use(t) {
    if (!t)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && Gs.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1))
      for (let n = 0; n < this.languages.length; n++) {
        const r = this.languages[n];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(t, n) {
    var r = this;
    this.isLanguageChangingTo = t;
    const s = bt();
    this.emit("languageChanging", t);
    const i = (u) => {
      this.language = u, this.languages = this.services.languageUtils.toResolveHierarchy(u), this.resolvedLanguage = void 0, this.setResolvedLanguage(u);
    }, a = (u, l) => {
      l ? (i(l), this.translator.changeLanguage(l), this.isLanguageChangingTo = void 0, this.emit("languageChanged", l), this.logger.log("languageChanged", l)) : this.isLanguageChangingTo = void 0, s.resolve(function() {
        return r.t(...arguments);
      }), n && n(u, function() {
        return r.t(...arguments);
      });
    }, o = (u) => {
      !t && !u && this.services.languageDetector && (u = []);
      const l = typeof u == "string" ? u : this.services.languageUtils.getBestMatchFromCodes(u);
      l && (this.language || i(l), this.translator.language || this.translator.changeLanguage(l), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(l)), this.loadResources(l, (f) => {
        a(f, l);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? o(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(o) : this.services.languageDetector.detect(o) : o(t), s;
  }
  getFixedT(t, n, r) {
    var s = this;
    const i = function(a, o) {
      let u;
      if (typeof o != "object") {
        for (var l = arguments.length, f = new Array(l > 2 ? l - 2 : 0), d = 2; d < l; d++)
          f[d - 2] = arguments[d];
        u = s.options.overloadTranslationOptionHandler([a, o].concat(f));
      } else
        u = {
          ...o
        };
      u.lng = u.lng || i.lng, u.lngs = u.lngs || i.lngs, u.ns = u.ns || i.ns, u.keyPrefix = u.keyPrefix || r || i.keyPrefix;
      const h = s.options.keySeparator || ".";
      let S;
      return u.keyPrefix && Array.isArray(a) ? S = a.map((p) => `${u.keyPrefix}${h}${p}`) : S = u.keyPrefix ? `${u.keyPrefix}${h}${a}` : a, s.t(S, u);
    };
    return typeof t == "string" ? i.lng = t : i.lngs = t, i.ns = n, i.keyPrefix = r, i;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = n.lng || this.resolvedLanguage || this.languages[0], s = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode")
      return !0;
    const a = (o, u) => {
      const l = this.services.backendConnector.state[`${o}|${u}`];
      return l === -1 || l === 2;
    };
    if (n.precheck) {
      const o = n.precheck(this, a);
      if (o !== void 0)
        return o;
    }
    return !!(this.hasResourceBundle(r, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || a(r, t) && (!s || a(i, t)));
  }
  loadNamespaces(t, n) {
    const r = bt();
    return this.options.ns ? (typeof t == "string" && (t = [t]), t.forEach((s) => {
      this.options.ns.indexOf(s) < 0 && this.options.ns.push(s);
    }), this.loadResources((s) => {
      r.resolve(), n && n(s);
    }), r) : (n && n(), Promise.resolve());
  }
  loadLanguages(t, n) {
    const r = bt();
    typeof t == "string" && (t = [t]);
    const s = this.options.preload || [], i = t.filter((a) => s.indexOf(a) < 0);
    return i.length ? (this.options.preload = s.concat(i), this.loadResources((a) => {
      r.resolve(), n && n(a);
    }), r) : (n && n(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !t)
      return "rtl";
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services && this.services.languageUtils || new ps(ys());
    return n.indexOf(r.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    return new Tt(t, n);
  }
  cloneInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Gt;
    const r = t.forkResourceStore;
    r && delete t.forkResourceStore;
    const s = {
      ...this.options,
      ...t,
      isClone: !0
    }, i = new Tt(s);
    return (t.debug !== void 0 || t.prefix !== void 0) && (i.logger = i.logger.clone(t)), ["store", "services", "language"].forEach((o) => {
      i[o] = this[o];
    }), i.services = {
      ...this.services
    }, i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, r && (i.store = new ds(this.store.data, s), i.services.resourceStore = i.store), i.translator = new an(i.services, s), i.translator.on("*", function(o) {
      for (var u = arguments.length, l = new Array(u > 1 ? u - 1 : 0), f = 1; f < u; f++)
        l[f - 1] = arguments[f];
      i.emit(o, ...l);
    }), i.init(s, n), i.translator.options = s, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const ne = Tt.createInstance();
ne.createInstance = Tt.createInstance;
ne.createInstance;
ne.dir;
ne.init;
ne.loadResources;
ne.reloadResources;
ne.use;
ne.changeLanguage;
ne.getFixedT;
ne.t;
ne.exists;
ne.setDefaultNamespace;
ne.hasLoadedNamespace;
ne.loadNamespaces;
ne.loadLanguages;
function Mo(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Dt(e) {
  "@babel/helpers - typeof";
  return Dt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Dt(e);
}
function Co(e, t) {
  if (Dt(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Dt(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ao(e) {
  var t = Co(e, "string");
  return Dt(t) == "symbol" ? t : t + "";
}
function Ss(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Ao(r.key), r);
  }
}
function Lo(e, t, n) {
  return t && Ss(e.prototype, t), n && Ss(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
var qs = [], Fo = qs.forEach, Io = qs.slice;
function Yo(e) {
  return Fo.call(Io.call(arguments, 1), function(t) {
    if (t)
      for (var n in t)
        e[n] === void 0 && (e[n] = t[n]);
  }), e;
}
var bs = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/, Uo = function(t, n, r) {
  var s = r || {};
  s.path = s.path || "/";
  var i = encodeURIComponent(n), a = "".concat(t, "=").concat(i);
  if (s.maxAge > 0) {
    var o = s.maxAge - 0;
    if (Number.isNaN(o))
      throw new Error("maxAge should be a Number");
    a += "; Max-Age=".concat(Math.floor(o));
  }
  if (s.domain) {
    if (!bs.test(s.domain))
      throw new TypeError("option domain is invalid");
    a += "; Domain=".concat(s.domain);
  }
  if (s.path) {
    if (!bs.test(s.path))
      throw new TypeError("option path is invalid");
    a += "; Path=".concat(s.path);
  }
  if (s.expires) {
    if (typeof s.expires.toUTCString != "function")
      throw new TypeError("option expires is invalid");
    a += "; Expires=".concat(s.expires.toUTCString());
  }
  if (s.httpOnly && (a += "; HttpOnly"), s.secure && (a += "; Secure"), s.sameSite) {
    var u = typeof s.sameSite == "string" ? s.sameSite.toLowerCase() : s.sameSite;
    switch (u) {
      case !0:
        a += "; SameSite=Strict";
        break;
      case "lax":
        a += "; SameSite=Lax";
        break;
      case "strict":
        a += "; SameSite=Strict";
        break;
      case "none":
        a += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  }
  return a;
}, vs = {
  create: function(t, n, r, s) {
    var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      path: "/",
      sameSite: "strict"
    };
    r && (i.expires = /* @__PURE__ */ new Date(), i.expires.setTime(i.expires.getTime() + r * 60 * 1e3)), s && (i.domain = s), document.cookie = Uo(t, encodeURIComponent(n), i);
  },
  read: function(t) {
    for (var n = "".concat(t, "="), r = document.cookie.split(";"), s = 0; s < r.length; s++) {
      for (var i = r[s]; i.charAt(0) === " "; )
        i = i.substring(1, i.length);
      if (i.indexOf(n) === 0)
        return i.substring(n.length, i.length);
    }
    return null;
  },
  remove: function(t) {
    this.create(t, "", -1);
  }
}, jo = {
  name: "cookie",
  lookup: function(t) {
    var n;
    if (t.lookupCookie && typeof document < "u") {
      var r = vs.read(t.lookupCookie);
      r && (n = r);
    }
    return n;
  },
  cacheUserLanguage: function(t, n) {
    n.lookupCookie && typeof document < "u" && vs.create(n.lookupCookie, t, n.cookieMinutes, n.cookieDomain, n.cookieOptions);
  }
}, $o = {
  name: "querystring",
  lookup: function(t) {
    var n;
    if (typeof window < "u") {
      var r = window.location.search;
      !window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1 && (r = window.location.hash.substring(window.location.hash.indexOf("?")));
      for (var s = r.substring(1), i = s.split("&"), a = 0; a < i.length; a++) {
        var o = i[a].indexOf("=");
        if (o > 0) {
          var u = i[a].substring(0, o);
          u === t.lookupQuerystring && (n = i[a].substring(o + 1));
        }
      }
    }
    return n;
  }
}, vt = null, _s = function() {
  if (vt !== null)
    return vt;
  try {
    vt = window !== "undefined" && window.localStorage !== null;
    var t = "i18next.translate.boo";
    window.localStorage.setItem(t, "foo"), window.localStorage.removeItem(t);
  } catch {
    vt = !1;
  }
  return vt;
}, Wo = {
  name: "localStorage",
  lookup: function(t) {
    var n;
    if (t.lookupLocalStorage && _s()) {
      var r = window.localStorage.getItem(t.lookupLocalStorage);
      r && (n = r);
    }
    return n;
  },
  cacheUserLanguage: function(t, n) {
    n.lookupLocalStorage && _s() && window.localStorage.setItem(n.lookupLocalStorage, t);
  }
}, _t = null, Os = function() {
  if (_t !== null)
    return _t;
  try {
    _t = window !== "undefined" && window.sessionStorage !== null;
    var t = "i18next.translate.boo";
    window.sessionStorage.setItem(t, "foo"), window.sessionStorage.removeItem(t);
  } catch {
    _t = !1;
  }
  return _t;
}, Ho = {
  name: "sessionStorage",
  lookup: function(t) {
    var n;
    if (t.lookupSessionStorage && Os()) {
      var r = window.sessionStorage.getItem(t.lookupSessionStorage);
      r && (n = r);
    }
    return n;
  },
  cacheUserLanguage: function(t, n) {
    n.lookupSessionStorage && Os() && window.sessionStorage.setItem(n.lookupSessionStorage, t);
  }
}, Vo = {
  name: "navigator",
  lookup: function(t) {
    var n = [];
    if (typeof navigator < "u") {
      if (navigator.languages)
        for (var r = 0; r < navigator.languages.length; r++)
          n.push(navigator.languages[r]);
      navigator.userLanguage && n.push(navigator.userLanguage), navigator.language && n.push(navigator.language);
    }
    return n.length > 0 ? n : void 0;
  }
}, Bo = {
  name: "htmlTag",
  lookup: function(t) {
    var n, r = t.htmlTag || (typeof document < "u" ? document.documentElement : null);
    return r && typeof r.getAttribute == "function" && (n = r.getAttribute("lang")), n;
  }
}, zo = {
  name: "path",
  lookup: function(t) {
    var n;
    if (typeof window < "u") {
      var r = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
      if (r instanceof Array)
        if (typeof t.lookupFromPathIndex == "number") {
          if (typeof r[t.lookupFromPathIndex] != "string")
            return;
          n = r[t.lookupFromPathIndex].replace("/", "");
        } else
          n = r[0].replace("/", "");
    }
    return n;
  }
}, Go = {
  name: "subdomain",
  lookup: function(t) {
    var n = typeof t.lookupFromSubdomainIndex == "number" ? t.lookupFromSubdomainIndex + 1 : 1, r = typeof window < "u" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
    if (r)
      return r[n];
  }
};
function qo() {
  return {
    order: ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"],
    lookupQuerystring: "lng",
    lookupCookie: "i18next",
    lookupLocalStorage: "i18nextLng",
    lookupSessionStorage: "i18nextLng",
    // cache user language
    caches: ["localStorage"],
    excludeCacheFor: ["cimode"],
    // cookieMinutes: 10,
    // cookieDomain: 'myDomain'
    convertDetectedLanguage: function(t) {
      return t;
    }
  };
}
var Ks = /* @__PURE__ */ function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Mo(this, e), this.type = "languageDetector", this.detectors = {}, this.init(t, n);
  }
  return Lo(e, [{
    key: "init",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.services = n || {
        languageUtils: {}
      }, this.options = Yo(r, this.options || {}, qo()), typeof this.options.convertDetectedLanguage == "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1 && (this.options.convertDetectedLanguage = function(i) {
        return i.replace("-", "_");
      }), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = s, this.addDetector(jo), this.addDetector($o), this.addDetector(Wo), this.addDetector(Ho), this.addDetector(Vo), this.addDetector(Bo), this.addDetector(zo), this.addDetector(Go);
    }
  }, {
    key: "addDetector",
    value: function(n) {
      return this.detectors[n.name] = n, this;
    }
  }, {
    key: "detect",
    value: function(n) {
      var r = this;
      n || (n = this.options.order);
      var s = [];
      return n.forEach(function(i) {
        if (r.detectors[i]) {
          var a = r.detectors[i].lookup(r.options);
          a && typeof a == "string" && (a = [a]), a && (s = s.concat(a));
        }
      }), s = s.map(function(i) {
        return r.options.convertDetectedLanguage(i);
      }), this.services.languageUtils.getBestMatchFromCodes ? s : s.length > 0 ? s[0] : null;
    }
  }, {
    key: "cacheUserLanguage",
    value: function(n, r) {
      var s = this;
      r || (r = this.options.caches), r && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(n) > -1 || r.forEach(function(i) {
        s.detectors[i] && s.detectors[i].cacheUserLanguage(n, s.options);
      }));
    }
  }]), e;
}();
Ks.type = "languageDetector";
const ot = ne.createInstance(), Ko = {
  name: "STLangDetector",
  lookup() {
    return typeof localStorage < "u" && localStorage.getItem("i18nextLng") || "en";
  }
}, Js = new Ks();
Js.addDetector(Ko);
ot.use(ro).use(Js).init({
  debug: !1,
  fallbackLng: "en",
  defaultNS: "translation",
  interpolation: { escapeValue: !1 },
  detection: {
    order: ["STLangDetector"]
  }
});
function Th(e, t) {
  if (e && !ot.hasResourceBundle("en", e))
    for (const n in t) {
      const r = t[n].default, s = n.replace(/\.[^/.]+$/, "").split("/").slice(-1)[0];
      ot.addResourceBundle(
        s,
        e,
        Object.entries(r).reduce((i, [a, o]) => ({ [a]: o, ...i }), {})
      );
    }
}
function Jo({ children: e, ns: t }) {
  return /* @__PURE__ */ Ba.jsx(oo, { i18n: ot, defaultNS: t ?? "common", children: e });
}
const Zo = ao, Dh = ot;
function Zs(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Qo } = Object.prototype, { getPrototypeOf: gr } = Object, pn = /* @__PURE__ */ ((e) => (t) => {
  const n = Qo.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), ke = (e) => (e = e.toLowerCase(), (t) => pn(t) === e), gn = (e) => (t) => typeof t === e, { isArray: lt } = Array, Pt = gn("undefined");
function Xo(e) {
  return e !== null && !Pt(e) && e.constructor !== null && !Pt(e.constructor) && fe(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Qs = ke("ArrayBuffer");
function eu(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Qs(e.buffer), t;
}
const tu = gn("string"), fe = gn("function"), Xs = gn("number"), mn = (e) => e !== null && typeof e == "object", nu = (e) => e === !0 || e === !1, Jt = (e) => {
  if (pn(e) !== "object")
    return !1;
  const t = gr(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, ru = ke("Date"), su = ke("File"), iu = ke("Blob"), au = ke("FileList"), ou = (e) => mn(e) && fe(e.pipe), uu = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || fe(e.append) && ((t = pn(e)) === "formdata" || // detect form-data instance
  t === "object" && fe(e.toString) && e.toString() === "[object FormData]"));
}, lu = ke("URLSearchParams"), cu = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Lt(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, s;
  if (typeof e != "object" && (e = [e]), lt(e))
    for (r = 0, s = e.length; r < s; r++)
      t.call(null, e[r], r, e);
  else {
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length;
    let o;
    for (r = 0; r < a; r++)
      o = i[r], t.call(null, e[o], o, e);
  }
}
function ei(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, s;
  for (; r-- > 0; )
    if (s = n[r], t === s.toLowerCase())
      return s;
  return null;
}
const ti = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, ni = (e) => !Pt(e) && e !== ti;
function rr() {
  const { caseless: e } = ni(this) && this || {}, t = {}, n = (r, s) => {
    const i = e && ei(t, s) || s;
    Jt(t[i]) && Jt(r) ? t[i] = rr(t[i], r) : Jt(r) ? t[i] = rr({}, r) : lt(r) ? t[i] = r.slice() : t[i] = r;
  };
  for (let r = 0, s = arguments.length; r < s; r++)
    arguments[r] && Lt(arguments[r], n);
  return t;
}
const fu = (e, t, n, { allOwnKeys: r } = {}) => (Lt(t, (s, i) => {
  n && fe(s) ? e[i] = Zs(s, n) : e[i] = s;
}, { allOwnKeys: r }), e), du = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), hu = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, pu = (e, t, n, r) => {
  let s, i, a;
  const o = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (s = Object.getOwnPropertyNames(e), i = s.length; i-- > 0; )
      a = s[i], (!r || r(a, e, t)) && !o[a] && (t[a] = e[a], o[a] = !0);
    e = n !== !1 && gr(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, gu = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, mu = (e) => {
  if (!e)
    return null;
  if (lt(e))
    return e;
  let t = e.length;
  if (!Xs(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, yu = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && gr(Uint8Array)), wu = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let s;
  for (; (s = r.next()) && !s.done; ) {
    const i = s.value;
    t.call(e, i[0], i[1]);
  }
}, Su = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, bu = ke("HTMLFormElement"), vu = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, s) {
    return r.toUpperCase() + s;
  }
), ks = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), _u = ke("RegExp"), ri = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  Lt(n, (s, i) => {
    let a;
    (a = t(s, i, e)) !== !1 && (r[i] = a || s);
  }), Object.defineProperties(e, r);
}, Ou = (e) => {
  ri(e, (t, n) => {
    if (fe(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (fe(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, ku = (e, t) => {
  const n = {}, r = (s) => {
    s.forEach((i) => {
      n[i] = !0;
    });
  };
  return lt(e) ? r(e) : r(String(e).split(t)), n;
}, xu = () => {
}, Ru = (e, t) => (e = +e, Number.isFinite(e) ? e : t), Wn = "abcdefghijklmnopqrstuvwxyz", xs = "0123456789", si = {
  DIGIT: xs,
  ALPHA: Wn,
  ALPHA_DIGIT: Wn + Wn.toUpperCase() + xs
}, Eu = (e = 16, t = si.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function Tu(e) {
  return !!(e && fe(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const Du = (e) => {
  const t = new Array(10), n = (r, s) => {
    if (mn(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[s] = r;
        const i = lt(r) ? [] : {};
        return Lt(r, (a, o) => {
          const u = n(a, s + 1);
          !Pt(u) && (i[o] = u);
        }), t[s] = void 0, i;
      }
    }
    return r;
  };
  return n(e, 0);
}, Pu = ke("AsyncFunction"), Nu = (e) => e && (mn(e) || fe(e)) && fe(e.then) && fe(e.catch), g = {
  isArray: lt,
  isArrayBuffer: Qs,
  isBuffer: Xo,
  isFormData: uu,
  isArrayBufferView: eu,
  isString: tu,
  isNumber: Xs,
  isBoolean: nu,
  isObject: mn,
  isPlainObject: Jt,
  isUndefined: Pt,
  isDate: ru,
  isFile: su,
  isBlob: iu,
  isRegExp: _u,
  isFunction: fe,
  isStream: ou,
  isURLSearchParams: lu,
  isTypedArray: yu,
  isFileList: au,
  forEach: Lt,
  merge: rr,
  extend: fu,
  trim: cu,
  stripBOM: du,
  inherits: hu,
  toFlatObject: pu,
  kindOf: pn,
  kindOfTest: ke,
  endsWith: gu,
  toArray: mu,
  forEachEntry: wu,
  matchAll: Su,
  isHTMLForm: bu,
  hasOwnProperty: ks,
  hasOwnProp: ks,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: ri,
  freezeMethods: Ou,
  toObjectSet: ku,
  toCamelCase: vu,
  noop: xu,
  toFiniteNumber: Ru,
  findKey: ei,
  global: ti,
  isContextDefined: ni,
  ALPHABET: si,
  generateString: Eu,
  isSpecCompliantForm: Tu,
  toJSONObject: Du,
  isAsyncFn: Pu,
  isThenable: Nu
};
function A(e, t, n, r, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), s && (this.response = s);
}
g.inherits(A, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: g.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const ii = A.prototype, ai = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  ai[e] = { value: e };
});
Object.defineProperties(A, ai);
Object.defineProperty(ii, "isAxiosError", { value: !0 });
A.from = (e, t, n, r, s, i) => {
  const a = Object.create(ii);
  return g.toFlatObject(e, a, function(u) {
    return u !== Error.prototype;
  }, (o) => o !== "isAxiosError"), A.call(a, e.message, t, n, r, s), a.cause = e, a.name = e.name, i && Object.assign(a, i), a;
};
const Mu = null;
function sr(e) {
  return g.isPlainObject(e) || g.isArray(e);
}
function oi(e) {
  return g.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Rs(e, t, n) {
  return e ? e.concat(t).map(function(s, i) {
    return s = oi(s), !n && i ? "[" + s + "]" : s;
  }).join(n ? "." : "") : t;
}
function Cu(e) {
  return g.isArray(e) && !e.some(sr);
}
const Au = g.toFlatObject(g, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function yn(e, t, n) {
  if (!g.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = g.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(y, _) {
    return !g.isUndefined(_[y]);
  });
  const r = n.metaTokens, s = n.visitor || f, i = n.dots, a = n.indexes, u = (n.Blob || typeof Blob < "u" && Blob) && g.isSpecCompliantForm(t);
  if (!g.isFunction(s))
    throw new TypeError("visitor must be a function");
  function l(p) {
    if (p === null)
      return "";
    if (g.isDate(p))
      return p.toISOString();
    if (!u && g.isBlob(p))
      throw new A("Blob is not supported. Use a Buffer instead.");
    return g.isArrayBuffer(p) || g.isTypedArray(p) ? u && typeof Blob == "function" ? new Blob([p]) : Buffer.from(p) : p;
  }
  function f(p, y, _) {
    let x = p;
    if (p && !_ && typeof p == "object") {
      if (g.endsWith(y, "{}"))
        y = r ? y : y.slice(0, -2), p = JSON.stringify(p);
      else if (g.isArray(p) && Cu(p) || (g.isFileList(p) || g.endsWith(y, "[]")) && (x = g.toArray(p)))
        return y = oi(y), x.forEach(function(P, D) {
          !(g.isUndefined(P) || P === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? Rs([y], D, i) : a === null ? y : y + "[]",
            l(P)
          );
        }), !1;
    }
    return sr(p) ? !0 : (t.append(Rs(_, y, i), l(p)), !1);
  }
  const d = [], h = Object.assign(Au, {
    defaultVisitor: f,
    convertValue: l,
    isVisitable: sr
  });
  function S(p, y) {
    if (!g.isUndefined(p)) {
      if (d.indexOf(p) !== -1)
        throw Error("Circular reference detected in " + y.join("."));
      d.push(p), g.forEach(p, function(x, k) {
        (!(g.isUndefined(x) || x === null) && s.call(
          t,
          x,
          g.isString(k) ? k.trim() : k,
          y,
          h
        )) === !0 && S(x, y ? y.concat(k) : [k]);
      }), d.pop();
    }
  }
  if (!g.isObject(e))
    throw new TypeError("data must be an object");
  return S(e), t;
}
function Es(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function mr(e, t) {
  this._pairs = [], e && yn(e, this, t);
}
const ui = mr.prototype;
ui.append = function(t, n) {
  this._pairs.push([t, n]);
};
ui.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, Es);
  } : Es;
  return this._pairs.map(function(s) {
    return n(s[0]) + "=" + n(s[1]);
  }, "").join("&");
};
function Lu(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function li(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || Lu, s = n && n.serialize;
  let i;
  if (s ? i = s(t, n) : i = g.isURLSearchParams(t) ? t.toString() : new mr(t, n).toString(r), i) {
    const a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class Ts {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    g.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const ci = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Fu = typeof URLSearchParams < "u" ? URLSearchParams : mr, Iu = typeof FormData < "u" ? FormData : null, Yu = typeof Blob < "u" ? Blob : null, Uu = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Fu,
    FormData: Iu,
    Blob: Yu
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, fi = typeof window < "u" && typeof document < "u", ju = ((e) => fi && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), $u = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Wu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: fi,
  hasStandardBrowserEnv: ju,
  hasStandardBrowserWebWorkerEnv: $u
}, Symbol.toStringTag, { value: "Module" })), _e = {
  ...Wu,
  ...Uu
};
function Hu(e, t) {
  return yn(e, new _e.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, s, i) {
      return _e.isNode && g.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function Vu(e) {
  return g.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Bu(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const s = n.length;
  let i;
  for (r = 0; r < s; r++)
    i = n[r], t[i] = e[i];
  return t;
}
function di(e) {
  function t(n, r, s, i) {
    let a = n[i++];
    if (a === "__proto__")
      return !0;
    const o = Number.isFinite(+a), u = i >= n.length;
    return a = !a && g.isArray(s) ? s.length : a, u ? (g.hasOwnProp(s, a) ? s[a] = [s[a], r] : s[a] = r, !o) : ((!s[a] || !g.isObject(s[a])) && (s[a] = []), t(n, r, s[a], i) && g.isArray(s[a]) && (s[a] = Bu(s[a])), !o);
  }
  if (g.isFormData(e) && g.isFunction(e.entries)) {
    const n = {};
    return g.forEachEntry(e, (r, s) => {
      t(Vu(r), s, n, 0);
    }), n;
  }
  return null;
}
function zu(e, t, n) {
  if (g.isString(e))
    try {
      return (t || JSON.parse)(e), g.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const yr = {
  transitional: ci,
  adapter: ["xhr", "http"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", s = r.indexOf("application/json") > -1, i = g.isObject(t);
    if (i && g.isHTMLForm(t) && (t = new FormData(t)), g.isFormData(t))
      return s ? JSON.stringify(di(t)) : t;
    if (g.isArrayBuffer(t) || g.isBuffer(t) || g.isStream(t) || g.isFile(t) || g.isBlob(t))
      return t;
    if (g.isArrayBufferView(t))
      return t.buffer;
    if (g.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let o;
    if (i) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return Hu(t, this.formSerializer).toString();
      if ((o = g.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const u = this.env && this.env.FormData;
        return yn(
          o ? { "files[]": t } : t,
          u && new u(),
          this.formSerializer
        );
      }
    }
    return i || s ? (n.setContentType("application/json", !1), zu(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || yr.transitional, r = n && n.forcedJSONParsing, s = this.responseType === "json";
    if (t && g.isString(t) && (r && !this.responseType || s)) {
      const a = !(n && n.silentJSONParsing) && s;
      try {
        return JSON.parse(t);
      } catch (o) {
        if (a)
          throw o.name === "SyntaxError" ? A.from(o, A.ERR_BAD_RESPONSE, this, null, this.response) : o;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: _e.classes.FormData,
    Blob: _e.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
g.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  yr.headers[e] = {};
});
const wr = yr, Gu = g.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), qu = (e) => {
  const t = {};
  let n, r, s;
  return e && e.split(`
`).forEach(function(a) {
    s = a.indexOf(":"), n = a.substring(0, s).trim().toLowerCase(), r = a.substring(s + 1).trim(), !(!n || t[n] && Gu[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, Ds = Symbol("internals");
function Ot(e) {
  return e && String(e).trim().toLowerCase();
}
function Zt(e) {
  return e === !1 || e == null ? e : g.isArray(e) ? e.map(Zt) : String(e);
}
function Ku(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const Ju = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Hn(e, t, n, r, s) {
  if (g.isFunction(r))
    return r.call(this, t, n);
  if (s && (t = n), !!g.isString(t)) {
    if (g.isString(r))
      return t.indexOf(r) !== -1;
    if (g.isRegExp(r))
      return r.test(t);
  }
}
function Zu(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function Qu(e, t) {
  const n = g.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(s, i, a) {
        return this[r].call(this, t, s, i, a);
      },
      configurable: !0
    });
  });
}
class wn {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const s = this;
    function i(o, u, l) {
      const f = Ot(u);
      if (!f)
        throw new Error("header name must be a non-empty string");
      const d = g.findKey(s, f);
      (!d || s[d] === void 0 || l === !0 || l === void 0 && s[d] !== !1) && (s[d || u] = Zt(o));
    }
    const a = (o, u) => g.forEach(o, (l, f) => i(l, f, u));
    return g.isPlainObject(t) || t instanceof this.constructor ? a(t, n) : g.isString(t) && (t = t.trim()) && !Ju(t) ? a(qu(t), n) : t != null && i(n, t, r), this;
  }
  get(t, n) {
    if (t = Ot(t), t) {
      const r = g.findKey(this, t);
      if (r) {
        const s = this[r];
        if (!n)
          return s;
        if (n === !0)
          return Ku(s);
        if (g.isFunction(n))
          return n.call(this, s, r);
        if (g.isRegExp(n))
          return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = Ot(t), t) {
      const r = g.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || Hn(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let s = !1;
    function i(a) {
      if (a = Ot(a), a) {
        const o = g.findKey(r, a);
        o && (!n || Hn(r, r[o], o, n)) && (delete r[o], s = !0);
      }
    }
    return g.isArray(t) ? t.forEach(i) : i(t), s;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, s = !1;
    for (; r--; ) {
      const i = n[r];
      (!t || Hn(this, this[i], i, t, !0)) && (delete this[i], s = !0);
    }
    return s;
  }
  normalize(t) {
    const n = this, r = {};
    return g.forEach(this, (s, i) => {
      const a = g.findKey(r, i);
      if (a) {
        n[a] = Zt(s), delete n[i];
        return;
      }
      const o = t ? Zu(i) : String(i).trim();
      o !== i && delete n[i], n[o] = Zt(s), r[o] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return g.forEach(this, (r, s) => {
      r != null && r !== !1 && (n[s] = t && g.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((s) => r.set(s)), r;
  }
  static accessor(t) {
    const r = (this[Ds] = this[Ds] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function i(a) {
      const o = Ot(a);
      r[o] || (Qu(s, a), r[o] = !0);
    }
    return g.isArray(t) ? t.forEach(i) : i(t), this;
  }
}
wn.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
g.reduceDescriptors(wn.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
g.freezeMethods(wn);
const Ne = wn;
function Vn(e, t) {
  const n = this || wr, r = t || n, s = Ne.from(r.headers);
  let i = r.data;
  return g.forEach(e, function(o) {
    i = o.call(n, i, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), i;
}
function hi(e) {
  return !!(e && e.__CANCEL__);
}
function Ft(e, t, n) {
  A.call(this, e ?? "canceled", A.ERR_CANCELED, t, n), this.name = "CanceledError";
}
g.inherits(Ft, A, {
  __CANCEL__: !0
});
function Xu(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new A(
    "Request failed with status code " + n.status,
    [A.ERR_BAD_REQUEST, A.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
const el = _e.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, s, i) {
      const a = [e + "=" + encodeURIComponent(t)];
      g.isNumber(n) && a.push("expires=" + new Date(n).toGMTString()), g.isString(r) && a.push("path=" + r), g.isString(s) && a.push("domain=" + s), i === !0 && a.push("secure"), document.cookie = a.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function tl(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function nl(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function pi(e, t) {
  return e && !tl(t) ? nl(e, t) : t;
}
const rl = _e.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let r;
    function s(i) {
      let a = i;
      return t && (n.setAttribute("href", a), a = n.href), n.setAttribute("href", a), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = s(window.location.href), function(a) {
      const o = g.isString(a) ? s(a) : a;
      return o.protocol === r.protocol && o.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
);
function sl(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function il(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let s = 0, i = 0, a;
  return t = t !== void 0 ? t : 1e3, function(u) {
    const l = Date.now(), f = r[i];
    a || (a = l), n[s] = u, r[s] = l;
    let d = i, h = 0;
    for (; d !== s; )
      h += n[d++], d = d % e;
    if (s = (s + 1) % e, s === i && (i = (i + 1) % e), l - a < t)
      return;
    const S = f && l - f;
    return S ? Math.round(h * 1e3 / S) : void 0;
  };
}
function Ps(e, t) {
  let n = 0;
  const r = il(50, 250);
  return (s) => {
    const i = s.loaded, a = s.lengthComputable ? s.total : void 0, o = i - n, u = r(o), l = i <= a;
    n = i;
    const f = {
      loaded: i,
      total: a,
      progress: a ? i / a : void 0,
      bytes: o,
      rate: u || void 0,
      estimated: u && a && l ? (a - i) / u : void 0,
      event: s
    };
    f[t ? "download" : "upload"] = !0, e(f);
  };
}
const al = typeof XMLHttpRequest < "u", ol = al && function(e) {
  return new Promise(function(n, r) {
    let s = e.data;
    const i = Ne.from(e.headers).normalize();
    let { responseType: a, withXSRFToken: o } = e, u;
    function l() {
      e.cancelToken && e.cancelToken.unsubscribe(u), e.signal && e.signal.removeEventListener("abort", u);
    }
    let f;
    if (g.isFormData(s)) {
      if (_e.hasStandardBrowserEnv || _e.hasStandardBrowserWebWorkerEnv)
        i.setContentType(!1);
      else if ((f = i.getContentType()) !== !1) {
        const [y, ..._] = f ? f.split(";").map((x) => x.trim()).filter(Boolean) : [];
        i.setContentType([y || "multipart/form-data", ..._].join("; "));
      }
    }
    let d = new XMLHttpRequest();
    if (e.auth) {
      const y = e.auth.username || "", _ = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      i.set("Authorization", "Basic " + btoa(y + ":" + _));
    }
    const h = pi(e.baseURL, e.url);
    d.open(e.method.toUpperCase(), li(h, e.params, e.paramsSerializer), !0), d.timeout = e.timeout;
    function S() {
      if (!d)
        return;
      const y = Ne.from(
        "getAllResponseHeaders" in d && d.getAllResponseHeaders()
      ), x = {
        data: !a || a === "text" || a === "json" ? d.responseText : d.response,
        status: d.status,
        statusText: d.statusText,
        headers: y,
        config: e,
        request: d
      };
      Xu(function(P) {
        n(P), l();
      }, function(P) {
        r(P), l();
      }, x), d = null;
    }
    if ("onloadend" in d ? d.onloadend = S : d.onreadystatechange = function() {
      !d || d.readyState !== 4 || d.status === 0 && !(d.responseURL && d.responseURL.indexOf("file:") === 0) || setTimeout(S);
    }, d.onabort = function() {
      d && (r(new A("Request aborted", A.ECONNABORTED, e, d)), d = null);
    }, d.onerror = function() {
      r(new A("Network Error", A.ERR_NETWORK, e, d)), d = null;
    }, d.ontimeout = function() {
      let _ = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const x = e.transitional || ci;
      e.timeoutErrorMessage && (_ = e.timeoutErrorMessage), r(new A(
        _,
        x.clarifyTimeoutError ? A.ETIMEDOUT : A.ECONNABORTED,
        e,
        d
      )), d = null;
    }, _e.hasStandardBrowserEnv && (o && g.isFunction(o) && (o = o(e)), o || o !== !1 && rl(h))) {
      const y = e.xsrfHeaderName && e.xsrfCookieName && el.read(e.xsrfCookieName);
      y && i.set(e.xsrfHeaderName, y);
    }
    s === void 0 && i.setContentType(null), "setRequestHeader" in d && g.forEach(i.toJSON(), function(_, x) {
      d.setRequestHeader(x, _);
    }), g.isUndefined(e.withCredentials) || (d.withCredentials = !!e.withCredentials), a && a !== "json" && (d.responseType = e.responseType), typeof e.onDownloadProgress == "function" && d.addEventListener("progress", Ps(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && d.upload && d.upload.addEventListener("progress", Ps(e.onUploadProgress)), (e.cancelToken || e.signal) && (u = (y) => {
      d && (r(!y || y.type ? new Ft(null, e, d) : y), d.abort(), d = null);
    }, e.cancelToken && e.cancelToken.subscribe(u), e.signal && (e.signal.aborted ? u() : e.signal.addEventListener("abort", u)));
    const p = sl(h);
    if (p && _e.protocols.indexOf(p) === -1) {
      r(new A("Unsupported protocol " + p + ":", A.ERR_BAD_REQUEST, e));
      return;
    }
    d.send(s || null);
  });
}, ir = {
  http: Mu,
  xhr: ol
};
g.forEach(ir, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Ns = (e) => `- ${e}`, ul = (e) => g.isFunction(e) || e === null || e === !1, gi = {
  getAdapter: (e) => {
    e = g.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const s = {};
    for (let i = 0; i < t; i++) {
      n = e[i];
      let a;
      if (r = n, !ul(n) && (r = ir[(a = String(n)).toLowerCase()], r === void 0))
        throw new A(`Unknown adapter '${a}'`);
      if (r)
        break;
      s[a || "#" + i] = r;
    }
    if (!r) {
      const i = Object.entries(s).map(
        ([o, u]) => `adapter ${o} ` + (u === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let a = t ? i.length > 1 ? `since :
` + i.map(Ns).join(`
`) : " " + Ns(i[0]) : "as no adapter specified";
      throw new A(
        "There is no suitable adapter to dispatch the request " + a,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: ir
};
function Bn(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Ft(null, e);
}
function Ms(e) {
  return Bn(e), e.headers = Ne.from(e.headers), e.data = Vn.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), gi.getAdapter(e.adapter || wr.adapter)(e).then(function(r) {
    return Bn(e), r.data = Vn.call(
      e,
      e.transformResponse,
      r
    ), r.headers = Ne.from(r.headers), r;
  }, function(r) {
    return hi(r) || (Bn(e), r && r.response && (r.response.data = Vn.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = Ne.from(r.response.headers))), Promise.reject(r);
  });
}
const Cs = (e) => e instanceof Ne ? { ...e } : e;
function ut(e, t) {
  t = t || {};
  const n = {};
  function r(l, f, d) {
    return g.isPlainObject(l) && g.isPlainObject(f) ? g.merge.call({ caseless: d }, l, f) : g.isPlainObject(f) ? g.merge({}, f) : g.isArray(f) ? f.slice() : f;
  }
  function s(l, f, d) {
    if (g.isUndefined(f)) {
      if (!g.isUndefined(l))
        return r(void 0, l, d);
    } else
      return r(l, f, d);
  }
  function i(l, f) {
    if (!g.isUndefined(f))
      return r(void 0, f);
  }
  function a(l, f) {
    if (g.isUndefined(f)) {
      if (!g.isUndefined(l))
        return r(void 0, l);
    } else
      return r(void 0, f);
  }
  function o(l, f, d) {
    if (d in t)
      return r(l, f);
    if (d in e)
      return r(void 0, l);
  }
  const u = {
    url: i,
    method: i,
    data: i,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    withXSRFToken: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: o,
    headers: (l, f) => s(Cs(l), Cs(f), !0)
  };
  return g.forEach(Object.keys(Object.assign({}, e, t)), function(f) {
    const d = u[f] || s, h = d(e[f], t[f], f);
    g.isUndefined(h) && d !== o || (n[f] = h);
  }), n;
}
const mi = "1.6.8", Sr = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Sr[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const As = {};
Sr.transitional = function(t, n, r) {
  function s(i, a) {
    return "[Axios v" + mi + "] Transitional option '" + i + "'" + a + (r ? ". " + r : "");
  }
  return (i, a, o) => {
    if (t === !1)
      throw new A(
        s(a, " has been removed" + (n ? " in " + n : "")),
        A.ERR_DEPRECATED
      );
    return n && !As[a] && (As[a] = !0, console.warn(
      s(
        a,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, a, o) : !0;
  };
};
function ll(e, t, n) {
  if (typeof e != "object")
    throw new A("options must be an object", A.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let s = r.length;
  for (; s-- > 0; ) {
    const i = r[s], a = t[i];
    if (a) {
      const o = e[i], u = o === void 0 || a(o, i, e);
      if (u !== !0)
        throw new A("option " + i + " must be " + u, A.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new A("Unknown option " + i, A.ERR_BAD_OPTION);
  }
}
const ar = {
  assertOptions: ll,
  validators: Sr
}, Ye = ar.validators;
class on {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new Ts(),
      response: new Ts()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let s;
        Error.captureStackTrace ? Error.captureStackTrace(s = {}) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = ut(this.defaults, n);
    const { transitional: r, paramsSerializer: s, headers: i } = n;
    r !== void 0 && ar.assertOptions(r, {
      silentJSONParsing: Ye.transitional(Ye.boolean),
      forcedJSONParsing: Ye.transitional(Ye.boolean),
      clarifyTimeoutError: Ye.transitional(Ye.boolean)
    }, !1), s != null && (g.isFunction(s) ? n.paramsSerializer = {
      serialize: s
    } : ar.assertOptions(s, {
      encode: Ye.function,
      serialize: Ye.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let a = i && g.merge(
      i.common,
      i[n.method]
    );
    i && g.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (p) => {
        delete i[p];
      }
    ), n.headers = Ne.concat(a, i);
    const o = [];
    let u = !0;
    this.interceptors.request.forEach(function(y) {
      typeof y.runWhen == "function" && y.runWhen(n) === !1 || (u = u && y.synchronous, o.unshift(y.fulfilled, y.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(y) {
      l.push(y.fulfilled, y.rejected);
    });
    let f, d = 0, h;
    if (!u) {
      const p = [Ms.bind(this), void 0];
      for (p.unshift.apply(p, o), p.push.apply(p, l), h = p.length, f = Promise.resolve(n); d < h; )
        f = f.then(p[d++], p[d++]);
      return f;
    }
    h = o.length;
    let S = n;
    for (d = 0; d < h; ) {
      const p = o[d++], y = o[d++];
      try {
        S = p(S);
      } catch (_) {
        y.call(this, _);
        break;
      }
    }
    try {
      f = Ms.call(this, S);
    } catch (p) {
      return Promise.reject(p);
    }
    for (d = 0, h = l.length; d < h; )
      f = f.then(l[d++], l[d++]);
    return f;
  }
  getUri(t) {
    t = ut(this.defaults, t);
    const n = pi(t.baseURL, t.url);
    return li(n, t.params, t.paramsSerializer);
  }
}
g.forEach(["delete", "get", "head", "options"], function(t) {
  on.prototype[t] = function(n, r) {
    return this.request(ut(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
g.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(i, a, o) {
      return this.request(ut(o || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: a
      }));
    };
  }
  on.prototype[t] = n(), on.prototype[t + "Form"] = n(!0);
});
const Qt = on;
class br {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const r = this;
    this.promise.then((s) => {
      if (!r._listeners)
        return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](s);
      r._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const a = new Promise((o) => {
        r.subscribe(o), i = o;
      }).then(s);
      return a.cancel = function() {
        r.unsubscribe(i);
      }, a;
    }, t(function(i, a, o) {
      r.reason || (r.reason = new Ft(i, a, o), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new br(function(s) {
        t = s;
      }),
      cancel: t
    };
  }
}
const cl = br;
function fl(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function dl(e) {
  return g.isObject(e) && e.isAxiosError === !0;
}
const or = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(or).forEach(([e, t]) => {
  or[t] = e;
});
const hl = or;
function yi(e) {
  const t = new Qt(e), n = Zs(Qt.prototype.request, t);
  return g.extend(n, Qt.prototype, t, { allOwnKeys: !0 }), g.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(s) {
    return yi(ut(e, s));
  }, n;
}
const Z = yi(wr);
Z.Axios = Qt;
Z.CanceledError = Ft;
Z.CancelToken = cl;
Z.isCancel = hi;
Z.VERSION = mi;
Z.toFormData = yn;
Z.AxiosError = A;
Z.Cancel = Z.CanceledError;
Z.all = function(t) {
  return Promise.all(t);
};
Z.spread = fl;
Z.isAxiosError = dl;
Z.mergeConfig = ut;
Z.AxiosHeaders = Ne;
Z.formToJSON = (e) => di(g.isHTMLForm(e) ? new FormData(e) : e);
Z.getAdapter = gi.getAdapter;
Z.HttpStatusCode = hl;
Z.default = Z;
const pl = 440, gl = async () => {
  const e = Sn();
  try {
    const t = e.getAccountsURL(), n = new Request(`${t}/exit`, {
      method: "GET",
      mode: "no-cors",
      credentials: "include"
    });
    await fetch(n);
  } catch (t) {
    console.log("error", t);
  }
}, ml = () => `${Sn().getAccountsURL()}/signin?session_expired=true`, yl = () => localStorage.removeItem("tokens"), wi = (e) => {
  var t;
  if (((t = e == null ? void 0 : e.response) == null ? void 0 : t.status) === pl) {
    gl(), yl();
    const n = window.location.href;
    setTimeout(
      () => window.location.href = ml() + "?redirect_path=" + n,
      2e3
    );
  }
  throw e;
}, Si = (e) => e, ee = Z.create();
ee.interceptors.response.use(Si, wi);
function zn() {
  return window.location.href.includes("syngentadigital.co.uk");
}
function wl() {
  let e;
  try {
    e = JSON.parse(localStorage.getItem("tokens") || "{}");
  } catch {
    e = null;
  }
  return e ? e == null ? void 0 : e.access_token : "";
}
var Sl = { VITE_MAPBOX_TOKEN: "pk.eyJ1Ijoic3RyaWRlcmVuZ2luZWVyaW5nIiwiYSI6ImNsMWdnM3BrbzBiemQzaHBiaDhja2RleXAifQ.0QfwjSzZeGiEjkkA-0dH6w", VITE_CJS_IGNORE_WARNING: "true", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
class nt {
  constructor() {
    this.currentEnv = null, this.accessToken = null, this.currentAppId = null, this.callbacksAfterSetToken = [], this.excludeAuthorities = !1, this.segmentKeyByEnv = {
      qa: "jPsCxtCxCLQ9dtfWIiNF7kyZ23rSrTTk",
      staging: "jH1ssOMCalPvGsSFjt7SmUlPti2AeqJc",
      beta: "jH1ssOMCalPvGsSFjt7SmUlPti2AeqJc",
      prod: "GRbdxrYNDBoFzBtrwKpyFQbTISpDxcyO",
      "internal-docs": "GRbdxrYNDBoFzBtrwKpyFQbTISpDxcyO"
    }, this.amplitudeKeyByEnv = {
      qa: "42976a2d14e669a9cf62613c0fab61bc",
      staging: "dc674c09f625e1a3b6e9be43495b1ee7",
      beta: "dc674c09f625e1a3b6e9be43495b1ee7",
      prod: "8da4299e9e5bb23d6b39ef85ed18a996",
      "internal-docs": "42976a2d14e669a9cf62613c0fab61bc"
    }, this.getUserCallback = () => null;
  }
  static getInstance() {
    return nt.instance || (nt.instance = new nt()), nt.instance;
  }
  setToken(t) {
    this.accessToken = t, this.callbacksAfterSetToken.forEach((n) => n());
  }
  getToken() {
    return this.accessToken || "";
  }
  addCallbackAfterSetToken(t) {
    this.callbacksAfterSetToken.push(t);
  }
  setCurrentAppId(t) {
    this.currentAppId = t;
  }
  getCurrentAppId() {
    return this.currentAppId || "";
  }
  setupAxiosInterceptor(t) {
    t.interceptors.response.use(Si, wi);
  }
  setCurrentEnv(t) {
    this.currentEnv = t;
  }
  getCurrentEnv() {
    return this.currentEnv ? this.currentEnv : Sl.ENV_NAME;
  }
  getSegmentKey() {
    return this.currentEnv ? this.segmentKeyByEnv[this.currentEnv] : this.segmentKeyByEnv.qa;
  }
  getAnalyticsKey() {
    return this.currentEnv ? this.amplitudeKeyByEnv[this.currentEnv] : this.amplitudeKeyByEnv.qa;
  }
  getDataBusURL() {
    const t = this.currentEnv === "internal-docs" ? "qa" : this.currentEnv;
    return t === "prod" ? "https://databus.cropwise.com/integrations" : `https://${t}.databus.cropwise.com/integrations`;
  }
  getConnectURL() {
    return (this.currentEnv === "internal-docs" ? "qa" : this.currentEnv) === "prod" ? "https://connect.cropwise.com/" : "https://dev.connect.cropwise.com/";
  }
  getAccountsURL() {
    const t = this.currentEnv === "internal-docs" ? "qa" : this.currentEnv;
    return t === "prod" ? `https://accounts${this.getCurrentHost()}` : `https://${t}.accounts${this.getCurrentHost()}`;
  }
  getFarmSettingsURL() {
    const t = this.currentEnv === "internal-docs" ? "qa" : this.currentEnv, n = t === "prod" ? "" : t === "beta" ? "staging." : `${t}.`;
    return zn() ? `https://${n}app.syngentadigital.co.uk` : `https://${n}app.cropwise.com`;
  }
  getAPIWSURL() {
    return `${this.getAPIURL().replace("http", "ws")}/v2/notifications/connect`;
  }
  getAPIURL() {
    switch (this.currentEnv) {
      case "internal-docs":
        return "/api";
      case "prod":
        return "https://api.base.cropwise.com";
      case "beta":
        return "https://api.staging.beta.base.strider.ag";
      case "qa":
        return "https://api.qa.base.cropwise.com";
      case "staging":
        return "https://api.staging.base.cropwise.com";
      default:
        return `https://api.${this.currentEnv}.base.cropwise.com`;
    }
  }
  getConnectAPIURL() {
    switch (this.currentEnv) {
      case "internal-docs":
        return "/api";
      case "prod":
        return "https://prod-api.databus.cropwise.com/valet";
      case "qa":
        return "https://qa-api.databus.cropwise.com/valet";
      case "staging":
      case "beta":
        return "https://uat-api.databus.cropwise.com/valet";
      default:
        return `https://${this.currentEnv}-api.databus.cropwise.com/valet`;
    }
  }
  getRolloutKey() {
    switch (this.currentEnv) {
      case "internal-docs":
      case "prod":
        return "5fc6828040159f74cfc07a1d";
      case "qa":
        return "613083f3e32f137d9dd2cc18";
      case "staging":
      case "beta":
        return "613083bbfd8c0053b608ad75";
      default:
        return "613083f3e32f137d9dd2cc18";
    }
  }
  getCurrentHost() {
    return zn() ? ".syngentadigital.co.uk" : ".cropwise.com";
  }
  getDefaultHeaders() {
    return {
      Authorization: `Bearer ${this.accessToken || wl()}`
    };
  }
  getLanguageHeaders() {
    return {
      "Accept-Language": zn() ? "en-GB" : ot.language
    };
  }
  getI18NInstance() {
    return { useTranslation: Zo, CWElementsI18NProvider: Jo };
  }
  setExcludeAuthorities(t) {
    this.excludeAuthorities = t;
  }
  getExcludeAuthorities() {
    return this.excludeAuthorities;
  }
  setUserCallback(t) {
    this.getUserCallback = t;
  }
}
function Sn() {
  return nt.getInstance();
}
function bl(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var bi;
function v() {
  return bi.apply(null, arguments);
}
function vl(e) {
  bi = e;
}
function me(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function Ge(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function F(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function vr(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (F(e, t))
      return !1;
  return !0;
}
function ie(e) {
  return e === void 0;
}
function Ae(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function It(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function vi(e, t) {
  var n = [], r, s = e.length;
  for (r = 0; r < s; ++r)
    n.push(t(e[r], r));
  return n;
}
function Ue(e, t) {
  for (var n in t)
    F(t, n) && (e[n] = t[n]);
  return F(t, "toString") && (e.toString = t.toString), F(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function xe(e, t, n, r) {
  return Vi(e, t, n, r, !0).utc();
}
function _l() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function T(e) {
  return e._pf == null && (e._pf = _l()), e._pf;
}
var ur;
Array.prototype.some ? ur = Array.prototype.some : ur = function(e) {
  var t = Object(this), n = t.length >>> 0, r;
  for (r = 0; r < n; r++)
    if (r in t && e.call(this, t[r], r, t))
      return !0;
  return !1;
};
function _r(e) {
  var t = null, n = !1, r = e._d && !isNaN(e._d.getTime());
  if (r && (t = T(e), n = ur.call(t.parsedDateParts, function(s) {
    return s != null;
  }), r = t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && n), e._strict && (r = r && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(e))
    e._isValid = r;
  else
    return r;
  return e._isValid;
}
function bn(e) {
  var t = xe(NaN);
  return e != null ? Ue(T(t), e) : T(t).userInvalidated = !0, t;
}
var Ls = v.momentProperties = [], Gn = !1;
function Or(e, t) {
  var n, r, s, i = Ls.length;
  if (ie(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), ie(t._i) || (e._i = t._i), ie(t._f) || (e._f = t._f), ie(t._l) || (e._l = t._l), ie(t._strict) || (e._strict = t._strict), ie(t._tzm) || (e._tzm = t._tzm), ie(t._isUTC) || (e._isUTC = t._isUTC), ie(t._offset) || (e._offset = t._offset), ie(t._pf) || (e._pf = T(t)), ie(t._locale) || (e._locale = t._locale), i > 0)
    for (n = 0; n < i; n++)
      r = Ls[n], s = t[r], ie(s) || (e[r] = s);
  return e;
}
function Yt(e) {
  Or(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), Gn === !1 && (Gn = !0, v.updateOffset(this), Gn = !1);
}
function ye(e) {
  return e instanceof Yt || e != null && e._isAMomentObject != null;
}
function _i(e) {
  v.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function de(e, t) {
  var n = !0;
  return Ue(function() {
    if (v.deprecationHandler != null && v.deprecationHandler(null, e), n) {
      var r = [], s, i, a, o = arguments.length;
      for (i = 0; i < o; i++) {
        if (s = "", typeof arguments[i] == "object") {
          s += `
[` + i + "] ";
          for (a in arguments[0])
            F(arguments[0], a) && (s += a + ": " + arguments[0][a] + ", ");
          s = s.slice(0, -2);
        } else
          s = arguments[i];
        r.push(s);
      }
      _i(
        e + `
Arguments: ` + Array.prototype.slice.call(r).join("") + `
` + new Error().stack
      ), n = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var Fs = {};
function Oi(e, t) {
  v.deprecationHandler != null && v.deprecationHandler(e, t), Fs[e] || (_i(t), Fs[e] = !0);
}
v.suppressDeprecationWarnings = !1;
v.deprecationHandler = null;
function Re(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function Ol(e) {
  var t, n;
  for (n in e)
    F(e, n) && (t = e[n], Re(t) ? this[n] = t : this["_" + n] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function lr(e, t) {
  var n = Ue({}, e), r;
  for (r in t)
    F(t, r) && (Ge(e[r]) && Ge(t[r]) ? (n[r] = {}, Ue(n[r], e[r]), Ue(n[r], t[r])) : t[r] != null ? n[r] = t[r] : delete n[r]);
  for (r in e)
    F(e, r) && !F(t, r) && Ge(e[r]) && (n[r] = Ue({}, n[r]));
  return n;
}
function kr(e) {
  e != null && this.set(e);
}
var cr;
Object.keys ? cr = Object.keys : cr = function(e) {
  var t, n = [];
  for (t in e)
    F(e, t) && n.push(t);
  return n;
};
var kl = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function xl(e, t, n) {
  var r = this._calendar[e] || this._calendar.sameElse;
  return Re(r) ? r.call(t, n) : r;
}
function Oe(e, t, n) {
  var r = "" + Math.abs(e), s = t - r.length, i = e >= 0;
  return (i ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, s)).toString().substr(1) + r;
}
var xr = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, qt = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, qn = {}, st = {};
function R(e, t, n, r) {
  var s = r;
  typeof r == "string" && (s = function() {
    return this[r]();
  }), e && (st[e] = s), t && (st[t[0]] = function() {
    return Oe(s.apply(this, arguments), t[1], t[2]);
  }), n && (st[n] = function() {
    return this.localeData().ordinal(
      s.apply(this, arguments),
      e
    );
  });
}
function Rl(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function El(e) {
  var t = e.match(xr), n, r;
  for (n = 0, r = t.length; n < r; n++)
    st[t[n]] ? t[n] = st[t[n]] : t[n] = Rl(t[n]);
  return function(s) {
    var i = "", a;
    for (a = 0; a < r; a++)
      i += Re(t[a]) ? t[a].call(s, e) : t[a];
    return i;
  };
}
function Xt(e, t) {
  return e.isValid() ? (t = ki(t, e.localeData()), qn[t] = qn[t] || El(t), qn[t](e)) : e.localeData().invalidDate();
}
function ki(e, t) {
  var n = 5;
  function r(s) {
    return t.longDateFormat(s) || s;
  }
  for (qt.lastIndex = 0; n >= 0 && qt.test(e); )
    e = e.replace(
      qt,
      r
    ), qt.lastIndex = 0, n -= 1;
  return e;
}
var Tl = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function Dl(e) {
  var t = this._longDateFormat[e], n = this._longDateFormat[e.toUpperCase()];
  return t || !n ? t : (this._longDateFormat[e] = n.match(xr).map(function(r) {
    return r === "MMMM" || r === "MM" || r === "DD" || r === "dddd" ? r.slice(1) : r;
  }).join(""), this._longDateFormat[e]);
}
var Pl = "Invalid date";
function Nl() {
  return this._invalidDate;
}
var Ml = "%d", Cl = /\d{1,2}/;
function Al(e) {
  return this._ordinal.replace("%d", e);
}
var Ll = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function Fl(e, t, n, r) {
  var s = this._relativeTime[n];
  return Re(s) ? s(e, t, n, r) : s.replace(/%d/i, e);
}
function Il(e, t) {
  var n = this._relativeTime[e > 0 ? "future" : "past"];
  return Re(n) ? n(t) : n.replace(/%s/i, t);
}
var Is = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function he(e) {
  return typeof e == "string" ? Is[e] || Is[e.toLowerCase()] : void 0;
}
function Rr(e) {
  var t = {}, n, r;
  for (r in e)
    F(e, r) && (n = he(r), n && (t[n] = e[r]));
  return t;
}
var Yl = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function Ul(e) {
  var t = [], n;
  for (n in e)
    F(e, n) && t.push({ unit: n, priority: Yl[n] });
  return t.sort(function(r, s) {
    return r.priority - s.priority;
  }), t;
}
var xi = /\d/, oe = /\d\d/, Ri = /\d{3}/, Er = /\d{4}/, vn = /[+-]?\d{6}/, B = /\d\d?/, Ei = /\d\d\d\d?/, Ti = /\d\d\d\d\d\d?/, _n = /\d{1,3}/, Tr = /\d{1,4}/, On = /[+-]?\d{1,6}/, ct = /\d+/, kn = /[+-]?\d+/, jl = /Z|[+-]\d\d:?\d\d/gi, xn = /Z|[+-]\d\d(?::?\d\d)?/gi, $l = /[+-]?\d+(\.\d{1,3})?/, Ut = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, ft = /^[1-9]\d?/, Dr = /^([1-9]\d|\d)/, un;
un = {};
function O(e, t, n) {
  un[e] = Re(t) ? t : function(r, s) {
    return r && n ? n : t;
  };
}
function Wl(e, t) {
  return F(un, e) ? un[e](t._strict, t._locale) : new RegExp(Hl(e));
}
function Hl(e) {
  return Me(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, n, r, s, i) {
        return n || r || s || i;
      }
    )
  );
}
function Me(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function ce(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function M(e) {
  var t = +e, n = 0;
  return t !== 0 && isFinite(t) && (n = ce(t)), n;
}
var fr = {};
function j(e, t) {
  var n, r = t, s;
  for (typeof e == "string" && (e = [e]), Ae(t) && (r = function(i, a) {
    a[t] = M(i);
  }), s = e.length, n = 0; n < s; n++)
    fr[e[n]] = r;
}
function jt(e, t) {
  j(e, function(n, r, s, i) {
    s._w = s._w || {}, t(n, s._w, s, i);
  });
}
function Vl(e, t, n) {
  t != null && F(fr, e) && fr[e](t, n._a, n, e);
}
function Rn(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
var te = 0, De = 1, be = 2, Q = 3, ge = 4, Pe = 5, ze = 6, Bl = 7, zl = 8;
R("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? Oe(e, 4) : "+" + e;
});
R(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
R(0, ["YYYY", 4], 0, "year");
R(0, ["YYYYY", 5], 0, "year");
R(0, ["YYYYYY", 6, !0], 0, "year");
O("Y", kn);
O("YY", B, oe);
O("YYYY", Tr, Er);
O("YYYYY", On, vn);
O("YYYYYY", On, vn);
j(["YYYYY", "YYYYYY"], te);
j("YYYY", function(e, t) {
  t[te] = e.length === 2 ? v.parseTwoDigitYear(e) : M(e);
});
j("YY", function(e, t) {
  t[te] = v.parseTwoDigitYear(e);
});
j("Y", function(e, t) {
  t[te] = parseInt(e, 10);
});
function Et(e) {
  return Rn(e) ? 366 : 365;
}
v.parseTwoDigitYear = function(e) {
  return M(e) + (M(e) > 68 ? 1900 : 2e3);
};
var Di = dt("FullYear", !0);
function Gl() {
  return Rn(this.year());
}
function dt(e, t) {
  return function(n) {
    return n != null ? (Pi(this, e, n), v.updateOffset(this, t), this) : Nt(this, e);
  };
}
function Nt(e, t) {
  if (!e.isValid())
    return NaN;
  var n = e._d, r = e._isUTC;
  switch (t) {
    case "Milliseconds":
      return r ? n.getUTCMilliseconds() : n.getMilliseconds();
    case "Seconds":
      return r ? n.getUTCSeconds() : n.getSeconds();
    case "Minutes":
      return r ? n.getUTCMinutes() : n.getMinutes();
    case "Hours":
      return r ? n.getUTCHours() : n.getHours();
    case "Date":
      return r ? n.getUTCDate() : n.getDate();
    case "Day":
      return r ? n.getUTCDay() : n.getDay();
    case "Month":
      return r ? n.getUTCMonth() : n.getMonth();
    case "FullYear":
      return r ? n.getUTCFullYear() : n.getFullYear();
    default:
      return NaN;
  }
}
function Pi(e, t, n) {
  var r, s, i, a, o;
  if (!(!e.isValid() || isNaN(n))) {
    switch (r = e._d, s = e._isUTC, t) {
      case "Milliseconds":
        return void (s ? r.setUTCMilliseconds(n) : r.setMilliseconds(n));
      case "Seconds":
        return void (s ? r.setUTCSeconds(n) : r.setSeconds(n));
      case "Minutes":
        return void (s ? r.setUTCMinutes(n) : r.setMinutes(n));
      case "Hours":
        return void (s ? r.setUTCHours(n) : r.setHours(n));
      case "Date":
        return void (s ? r.setUTCDate(n) : r.setDate(n));
      case "FullYear":
        break;
      default:
        return;
    }
    i = n, a = e.month(), o = e.date(), o = o === 29 && a === 1 && !Rn(i) ? 28 : o, s ? r.setUTCFullYear(i, a, o) : r.setFullYear(i, a, o);
  }
}
function ql(e) {
  return e = he(e), Re(this[e]) ? this[e]() : this;
}
function Kl(e, t) {
  if (typeof e == "object") {
    e = Rr(e);
    var n = Ul(e), r, s = n.length;
    for (r = 0; r < s; r++)
      this[n[r].unit](e[n[r].unit]);
  } else if (e = he(e), Re(this[e]))
    return this[e](t);
  return this;
}
function Jl(e, t) {
  return (e % t + t) % t;
}
var q;
Array.prototype.indexOf ? q = Array.prototype.indexOf : q = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function Pr(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var n = Jl(t, 12);
  return e += (t - n) / 12, n === 1 ? Rn(e) ? 29 : 28 : 31 - n % 7 % 2;
}
R("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
R("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
R("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
O("M", B, ft);
O("MM", B, oe);
O("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
O("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
j(["M", "MM"], function(e, t) {
  t[De] = M(e) - 1;
});
j(["MMM", "MMMM"], function(e, t, n, r) {
  var s = n._locale.monthsParse(e, r, n._strict);
  s != null ? t[De] = s : T(n).invalidMonth = e;
});
var Zl = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), Ni = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), Mi = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, Ql = Ut, Xl = Ut;
function ec(e, t) {
  return e ? me(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || Mi).test(t) ? "format" : "standalone"][e.month()] : me(this._months) ? this._months : this._months.standalone;
}
function tc(e, t) {
  return e ? me(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[Mi.test(t) ? "format" : "standalone"][e.month()] : me(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function nc(e, t, n) {
  var r, s, i, a = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], r = 0; r < 12; ++r)
      i = xe([2e3, r]), this._shortMonthsParse[r] = this.monthsShort(
        i,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[r] = this.months(i, "").toLocaleLowerCase();
  return n ? t === "MMM" ? (s = q.call(this._shortMonthsParse, a), s !== -1 ? s : null) : (s = q.call(this._longMonthsParse, a), s !== -1 ? s : null) : t === "MMM" ? (s = q.call(this._shortMonthsParse, a), s !== -1 ? s : (s = q.call(this._longMonthsParse, a), s !== -1 ? s : null)) : (s = q.call(this._longMonthsParse, a), s !== -1 ? s : (s = q.call(this._shortMonthsParse, a), s !== -1 ? s : null));
}
function rc(e, t, n) {
  var r, s, i;
  if (this._monthsParseExact)
    return nc.call(this, e, t, n);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), r = 0; r < 12; r++) {
    if (s = xe([2e3, r]), n && !this._longMonthsParse[r] && (this._longMonthsParse[r] = new RegExp(
      "^" + this.months(s, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[r] = new RegExp(
      "^" + this.monthsShort(s, "").replace(".", "") + "$",
      "i"
    )), !n && !this._monthsParse[r] && (i = "^" + this.months(s, "") + "|^" + this.monthsShort(s, ""), this._monthsParse[r] = new RegExp(i.replace(".", ""), "i")), n && t === "MMMM" && this._longMonthsParse[r].test(e))
      return r;
    if (n && t === "MMM" && this._shortMonthsParse[r].test(e))
      return r;
    if (!n && this._monthsParse[r].test(e))
      return r;
  }
}
function Ci(e, t) {
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = M(t);
    else if (t = e.localeData().monthsParse(t), !Ae(t))
      return e;
  }
  var n = t, r = e.date();
  return r = r < 29 ? r : Math.min(r, Pr(e.year(), n)), e._isUTC ? e._d.setUTCMonth(n, r) : e._d.setMonth(n, r), e;
}
function Ai(e) {
  return e != null ? (Ci(this, e), v.updateOffset(this, !0), this) : Nt(this, "Month");
}
function sc() {
  return Pr(this.year(), this.month());
}
function ic(e) {
  return this._monthsParseExact ? (F(this, "_monthsRegex") || Li.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (F(this, "_monthsShortRegex") || (this._monthsShortRegex = Ql), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function ac(e) {
  return this._monthsParseExact ? (F(this, "_monthsRegex") || Li.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (F(this, "_monthsRegex") || (this._monthsRegex = Xl), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function Li() {
  function e(u, l) {
    return l.length - u.length;
  }
  var t = [], n = [], r = [], s, i, a, o;
  for (s = 0; s < 12; s++)
    i = xe([2e3, s]), a = Me(this.monthsShort(i, "")), o = Me(this.months(i, "")), t.push(a), n.push(o), r.push(o), r.push(a);
  t.sort(e), n.sort(e), r.sort(e), this._monthsRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function oc(e, t, n, r, s, i, a) {
  var o;
  return e < 100 && e >= 0 ? (o = new Date(e + 400, t, n, r, s, i, a), isFinite(o.getFullYear()) && o.setFullYear(e)) : o = new Date(e, t, n, r, s, i, a), o;
}
function Mt(e) {
  var t, n;
  return e < 100 && e >= 0 ? (n = Array.prototype.slice.call(arguments), n[0] = e + 400, t = new Date(Date.UTC.apply(null, n)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function ln(e, t, n) {
  var r = 7 + t - n, s = (7 + Mt(e, 0, r).getUTCDay() - t) % 7;
  return -s + r - 1;
}
function Fi(e, t, n, r, s) {
  var i = (7 + n - r) % 7, a = ln(e, r, s), o = 1 + 7 * (t - 1) + i + a, u, l;
  return o <= 0 ? (u = e - 1, l = Et(u) + o) : o > Et(e) ? (u = e + 1, l = o - Et(e)) : (u = e, l = o), {
    year: u,
    dayOfYear: l
  };
}
function Ct(e, t, n) {
  var r = ln(e.year(), t, n), s = Math.floor((e.dayOfYear() - r - 1) / 7) + 1, i, a;
  return s < 1 ? (a = e.year() - 1, i = s + Ce(a, t, n)) : s > Ce(e.year(), t, n) ? (i = s - Ce(e.year(), t, n), a = e.year() + 1) : (a = e.year(), i = s), {
    week: i,
    year: a
  };
}
function Ce(e, t, n) {
  var r = ln(e, t, n), s = ln(e + 1, t, n);
  return (Et(e) - r + s) / 7;
}
R("w", ["ww", 2], "wo", "week");
R("W", ["WW", 2], "Wo", "isoWeek");
O("w", B, ft);
O("ww", B, oe);
O("W", B, ft);
O("WW", B, oe);
jt(
  ["w", "ww", "W", "WW"],
  function(e, t, n, r) {
    t[r.substr(0, 1)] = M(e);
  }
);
function uc(e) {
  return Ct(e, this._week.dow, this._week.doy).week;
}
var lc = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function cc() {
  return this._week.dow;
}
function fc() {
  return this._week.doy;
}
function dc(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function hc(e) {
  var t = Ct(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
R("d", 0, "do", "day");
R("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
R("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
R("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
R("e", 0, 0, "weekday");
R("E", 0, 0, "isoWeekday");
O("d", B);
O("e", B);
O("E", B);
O("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
O("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
O("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
jt(["dd", "ddd", "dddd"], function(e, t, n, r) {
  var s = n._locale.weekdaysParse(e, r, n._strict);
  s != null ? t.d = s : T(n).invalidWeekday = e;
});
jt(["d", "e", "E"], function(e, t, n, r) {
  t[r] = M(e);
});
function pc(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function gc(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function Nr(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var mc = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), Ii = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), yc = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), wc = Ut, Sc = Ut, bc = Ut;
function vc(e, t) {
  var n = me(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? Nr(n, this._week.dow) : e ? n[e.day()] : n;
}
function _c(e) {
  return e === !0 ? Nr(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function Oc(e) {
  return e === !0 ? Nr(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function kc(e, t, n) {
  var r, s, i, a = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], r = 0; r < 7; ++r)
      i = xe([2e3, 1]).day(r), this._minWeekdaysParse[r] = this.weekdaysMin(
        i,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[r] = this.weekdaysShort(
        i,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[r] = this.weekdays(i, "").toLocaleLowerCase();
  return n ? t === "dddd" ? (s = q.call(this._weekdaysParse, a), s !== -1 ? s : null) : t === "ddd" ? (s = q.call(this._shortWeekdaysParse, a), s !== -1 ? s : null) : (s = q.call(this._minWeekdaysParse, a), s !== -1 ? s : null) : t === "dddd" ? (s = q.call(this._weekdaysParse, a), s !== -1 || (s = q.call(this._shortWeekdaysParse, a), s !== -1) ? s : (s = q.call(this._minWeekdaysParse, a), s !== -1 ? s : null)) : t === "ddd" ? (s = q.call(this._shortWeekdaysParse, a), s !== -1 || (s = q.call(this._weekdaysParse, a), s !== -1) ? s : (s = q.call(this._minWeekdaysParse, a), s !== -1 ? s : null)) : (s = q.call(this._minWeekdaysParse, a), s !== -1 || (s = q.call(this._weekdaysParse, a), s !== -1) ? s : (s = q.call(this._shortWeekdaysParse, a), s !== -1 ? s : null));
}
function xc(e, t, n) {
  var r, s, i;
  if (this._weekdaysParseExact)
    return kc.call(this, e, t, n);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), r = 0; r < 7; r++) {
    if (s = xe([2e3, 1]).day(r), n && !this._fullWeekdaysParse[r] && (this._fullWeekdaysParse[r] = new RegExp(
      "^" + this.weekdays(s, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[r] = new RegExp(
      "^" + this.weekdaysShort(s, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[r] = new RegExp(
      "^" + this.weekdaysMin(s, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[r] || (i = "^" + this.weekdays(s, "") + "|^" + this.weekdaysShort(s, "") + "|^" + this.weekdaysMin(s, ""), this._weekdaysParse[r] = new RegExp(i.replace(".", ""), "i")), n && t === "dddd" && this._fullWeekdaysParse[r].test(e))
      return r;
    if (n && t === "ddd" && this._shortWeekdaysParse[r].test(e))
      return r;
    if (n && t === "dd" && this._minWeekdaysParse[r].test(e))
      return r;
    if (!n && this._weekdaysParse[r].test(e))
      return r;
  }
}
function Rc(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = Nt(this, "Day");
  return e != null ? (e = pc(e, this.localeData()), this.add(e - t, "d")) : t;
}
function Ec(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function Tc(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = gc(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function Dc(e) {
  return this._weekdaysParseExact ? (F(this, "_weekdaysRegex") || Mr.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (F(this, "_weekdaysRegex") || (this._weekdaysRegex = wc), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function Pc(e) {
  return this._weekdaysParseExact ? (F(this, "_weekdaysRegex") || Mr.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (F(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Sc), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function Nc(e) {
  return this._weekdaysParseExact ? (F(this, "_weekdaysRegex") || Mr.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (F(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = bc), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function Mr() {
  function e(f, d) {
    return d.length - f.length;
  }
  var t = [], n = [], r = [], s = [], i, a, o, u, l;
  for (i = 0; i < 7; i++)
    a = xe([2e3, 1]).day(i), o = Me(this.weekdaysMin(a, "")), u = Me(this.weekdaysShort(a, "")), l = Me(this.weekdays(a, "")), t.push(o), n.push(u), r.push(l), s.push(o), s.push(u), s.push(l);
  t.sort(e), n.sort(e), r.sort(e), s.sort(e), this._weekdaysRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function Cr() {
  return this.hours() % 12 || 12;
}
function Mc() {
  return this.hours() || 24;
}
R("H", ["HH", 2], 0, "hour");
R("h", ["hh", 2], 0, Cr);
R("k", ["kk", 2], 0, Mc);
R("hmm", 0, 0, function() {
  return "" + Cr.apply(this) + Oe(this.minutes(), 2);
});
R("hmmss", 0, 0, function() {
  return "" + Cr.apply(this) + Oe(this.minutes(), 2) + Oe(this.seconds(), 2);
});
R("Hmm", 0, 0, function() {
  return "" + this.hours() + Oe(this.minutes(), 2);
});
R("Hmmss", 0, 0, function() {
  return "" + this.hours() + Oe(this.minutes(), 2) + Oe(this.seconds(), 2);
});
function Yi(e, t) {
  R(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
Yi("a", !0);
Yi("A", !1);
function Ui(e, t) {
  return t._meridiemParse;
}
O("a", Ui);
O("A", Ui);
O("H", B, Dr);
O("h", B, ft);
O("k", B, ft);
O("HH", B, oe);
O("hh", B, oe);
O("kk", B, oe);
O("hmm", Ei);
O("hmmss", Ti);
O("Hmm", Ei);
O("Hmmss", Ti);
j(["H", "HH"], Q);
j(["k", "kk"], function(e, t, n) {
  var r = M(e);
  t[Q] = r === 24 ? 0 : r;
});
j(["a", "A"], function(e, t, n) {
  n._isPm = n._locale.isPM(e), n._meridiem = e;
});
j(["h", "hh"], function(e, t, n) {
  t[Q] = M(e), T(n).bigHour = !0;
});
j("hmm", function(e, t, n) {
  var r = e.length - 2;
  t[Q] = M(e.substr(0, r)), t[ge] = M(e.substr(r)), T(n).bigHour = !0;
});
j("hmmss", function(e, t, n) {
  var r = e.length - 4, s = e.length - 2;
  t[Q] = M(e.substr(0, r)), t[ge] = M(e.substr(r, 2)), t[Pe] = M(e.substr(s)), T(n).bigHour = !0;
});
j("Hmm", function(e, t, n) {
  var r = e.length - 2;
  t[Q] = M(e.substr(0, r)), t[ge] = M(e.substr(r));
});
j("Hmmss", function(e, t, n) {
  var r = e.length - 4, s = e.length - 2;
  t[Q] = M(e.substr(0, r)), t[ge] = M(e.substr(r, 2)), t[Pe] = M(e.substr(s));
});
function Cc(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var Ac = /[ap]\.?m?\.?/i, Lc = dt("Hours", !0);
function Fc(e, t, n) {
  return e > 11 ? n ? "pm" : "PM" : n ? "am" : "AM";
}
var ji = {
  calendar: kl,
  longDateFormat: Tl,
  invalidDate: Pl,
  ordinal: Ml,
  dayOfMonthOrdinalParse: Cl,
  relativeTime: Ll,
  months: Zl,
  monthsShort: Ni,
  week: lc,
  weekdays: mc,
  weekdaysMin: yc,
  weekdaysShort: Ii,
  meridiemParse: Ac
}, z = {}, kt = {}, At;
function Ic(e, t) {
  var n, r = Math.min(e.length, t.length);
  for (n = 0; n < r; n += 1)
    if (e[n] !== t[n])
      return n;
  return r;
}
function Ys(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function Yc(e) {
  for (var t = 0, n, r, s, i; t < e.length; ) {
    for (i = Ys(e[t]).split("-"), n = i.length, r = Ys(e[t + 1]), r = r ? r.split("-") : null; n > 0; ) {
      if (s = En(i.slice(0, n).join("-")), s)
        return s;
      if (r && r.length >= n && Ic(i, r) >= n - 1)
        break;
      n--;
    }
    t++;
  }
  return At;
}
function Uc(e) {
  return !!(e && e.match("^[^/\\\\]*$"));
}
function En(e) {
  var t = null, n;
  if (z[e] === void 0 && typeof module < "u" && module && module.exports && Uc(e))
    try {
      t = At._abbr, n = bl, n("./locale/" + e), $e(t);
    } catch {
      z[e] = null;
    }
  return z[e];
}
function $e(e, t) {
  var n;
  return e && (ie(t) ? n = Le(e) : n = Ar(e, t), n ? At = n : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), At._abbr;
}
function Ar(e, t) {
  if (t !== null) {
    var n, r = ji;
    if (t.abbr = e, z[e] != null)
      Oi(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), r = z[e]._config;
    else if (t.parentLocale != null)
      if (z[t.parentLocale] != null)
        r = z[t.parentLocale]._config;
      else if (n = En(t.parentLocale), n != null)
        r = n._config;
      else
        return kt[t.parentLocale] || (kt[t.parentLocale] = []), kt[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return z[e] = new kr(lr(r, t)), kt[e] && kt[e].forEach(function(s) {
      Ar(s.name, s.config);
    }), $e(e), z[e];
  } else
    return delete z[e], null;
}
function jc(e, t) {
  if (t != null) {
    var n, r, s = ji;
    z[e] != null && z[e].parentLocale != null ? z[e].set(lr(z[e]._config, t)) : (r = En(e), r != null && (s = r._config), t = lr(s, t), r == null && (t.abbr = e), n = new kr(t), n.parentLocale = z[e], z[e] = n), $e(e);
  } else
    z[e] != null && (z[e].parentLocale != null ? (z[e] = z[e].parentLocale, e === $e() && $e(e)) : z[e] != null && delete z[e]);
  return z[e];
}
function Le(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return At;
  if (!me(e)) {
    if (t = En(e), t)
      return t;
    e = [e];
  }
  return Yc(e);
}
function $c() {
  return cr(z);
}
function Lr(e) {
  var t, n = e._a;
  return n && T(e).overflow === -2 && (t = n[De] < 0 || n[De] > 11 ? De : n[be] < 1 || n[be] > Pr(n[te], n[De]) ? be : n[Q] < 0 || n[Q] > 24 || n[Q] === 24 && (n[ge] !== 0 || n[Pe] !== 0 || n[ze] !== 0) ? Q : n[ge] < 0 || n[ge] > 59 ? ge : n[Pe] < 0 || n[Pe] > 59 ? Pe : n[ze] < 0 || n[ze] > 999 ? ze : -1, T(e)._overflowDayOfYear && (t < te || t > be) && (t = be), T(e)._overflowWeeks && t === -1 && (t = Bl), T(e)._overflowWeekday && t === -1 && (t = zl), T(e).overflow = t), e;
}
var Wc = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Hc = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Vc = /Z|[+-]\d\d(?::?\d\d)?/, Kt = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], Kn = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], Bc = /^\/?Date\((-?\d+)/i, zc = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, Gc = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function $i(e) {
  var t, n, r = e._i, s = Wc.exec(r) || Hc.exec(r), i, a, o, u, l = Kt.length, f = Kn.length;
  if (s) {
    for (T(e).iso = !0, t = 0, n = l; t < n; t++)
      if (Kt[t][1].exec(s[1])) {
        a = Kt[t][0], i = Kt[t][2] !== !1;
        break;
      }
    if (a == null) {
      e._isValid = !1;
      return;
    }
    if (s[3]) {
      for (t = 0, n = f; t < n; t++)
        if (Kn[t][1].exec(s[3])) {
          o = (s[2] || " ") + Kn[t][0];
          break;
        }
      if (o == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!i && o != null) {
      e._isValid = !1;
      return;
    }
    if (s[4])
      if (Vc.exec(s[4]))
        u = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = a + (o || "") + (u || ""), Ir(e);
  } else
    e._isValid = !1;
}
function qc(e, t, n, r, s, i) {
  var a = [
    Kc(e),
    Ni.indexOf(t),
    parseInt(n, 10),
    parseInt(r, 10),
    parseInt(s, 10)
  ];
  return i && a.push(parseInt(i, 10)), a;
}
function Kc(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function Jc(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function Zc(e, t, n) {
  if (e) {
    var r = Ii.indexOf(e), s = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (r !== s)
      return T(n).weekdayMismatch = !0, n._isValid = !1, !1;
  }
  return !0;
}
function Qc(e, t, n) {
  if (e)
    return Gc[e];
  if (t)
    return 0;
  var r = parseInt(n, 10), s = r % 100, i = (r - s) / 100;
  return i * 60 + s;
}
function Wi(e) {
  var t = zc.exec(Jc(e._i)), n;
  if (t) {
    if (n = qc(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !Zc(t[1], n, e))
      return;
    e._a = n, e._tzm = Qc(t[8], t[9], t[10]), e._d = Mt.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), T(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function Xc(e) {
  var t = Bc.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if ($i(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (Wi(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : v.createFromInputFallback(e);
}
v.createFromInputFallback = de(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function tt(e, t, n) {
  return e ?? t ?? n;
}
function ef(e) {
  var t = new Date(v.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function Fr(e) {
  var t, n, r = [], s, i, a;
  if (!e._d) {
    for (s = ef(e), e._w && e._a[be] == null && e._a[De] == null && tf(e), e._dayOfYear != null && (a = tt(e._a[te], s[te]), (e._dayOfYear > Et(a) || e._dayOfYear === 0) && (T(e)._overflowDayOfYear = !0), n = Mt(a, 0, e._dayOfYear), e._a[De] = n.getUTCMonth(), e._a[be] = n.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = r[t] = s[t];
    for (; t < 7; t++)
      e._a[t] = r[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[Q] === 24 && e._a[ge] === 0 && e._a[Pe] === 0 && e._a[ze] === 0 && (e._nextDay = !0, e._a[Q] = 0), e._d = (e._useUTC ? Mt : oc).apply(
      null,
      r
    ), i = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[Q] = 24), e._w && typeof e._w.d < "u" && e._w.d !== i && (T(e).weekdayMismatch = !0);
  }
}
function tf(e) {
  var t, n, r, s, i, a, o, u, l;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (i = 1, a = 4, n = tt(
    t.GG,
    e._a[te],
    Ct(V(), 1, 4).year
  ), r = tt(t.W, 1), s = tt(t.E, 1), (s < 1 || s > 7) && (u = !0)) : (i = e._locale._week.dow, a = e._locale._week.doy, l = Ct(V(), i, a), n = tt(t.gg, e._a[te], l.year), r = tt(t.w, l.week), t.d != null ? (s = t.d, (s < 0 || s > 6) && (u = !0)) : t.e != null ? (s = t.e + i, (t.e < 0 || t.e > 6) && (u = !0)) : s = i), r < 1 || r > Ce(n, i, a) ? T(e)._overflowWeeks = !0 : u != null ? T(e)._overflowWeekday = !0 : (o = Fi(n, r, s, i, a), e._a[te] = o.year, e._dayOfYear = o.dayOfYear);
}
v.ISO_8601 = function() {
};
v.RFC_2822 = function() {
};
function Ir(e) {
  if (e._f === v.ISO_8601) {
    $i(e);
    return;
  }
  if (e._f === v.RFC_2822) {
    Wi(e);
    return;
  }
  e._a = [], T(e).empty = !0;
  var t = "" + e._i, n, r, s, i, a, o = t.length, u = 0, l, f;
  for (s = ki(e._f, e._locale).match(xr) || [], f = s.length, n = 0; n < f; n++)
    i = s[n], r = (t.match(Wl(i, e)) || [])[0], r && (a = t.substr(0, t.indexOf(r)), a.length > 0 && T(e).unusedInput.push(a), t = t.slice(
      t.indexOf(r) + r.length
    ), u += r.length), st[i] ? (r ? T(e).empty = !1 : T(e).unusedTokens.push(i), Vl(i, r, e)) : e._strict && !r && T(e).unusedTokens.push(i);
  T(e).charsLeftOver = o - u, t.length > 0 && T(e).unusedInput.push(t), e._a[Q] <= 12 && T(e).bigHour === !0 && e._a[Q] > 0 && (T(e).bigHour = void 0), T(e).parsedDateParts = e._a.slice(0), T(e).meridiem = e._meridiem, e._a[Q] = nf(
    e._locale,
    e._a[Q],
    e._meridiem
  ), l = T(e).era, l !== null && (e._a[te] = e._locale.erasConvertYear(l, e._a[te])), Fr(e), Lr(e);
}
function nf(e, t, n) {
  var r;
  return n == null ? t : e.meridiemHour != null ? e.meridiemHour(t, n) : (e.isPM != null && (r = e.isPM(n), r && t < 12 && (t += 12), !r && t === 12 && (t = 0)), t);
}
function rf(e) {
  var t, n, r, s, i, a, o = !1, u = e._f.length;
  if (u === 0) {
    T(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (s = 0; s < u; s++)
    i = 0, a = !1, t = Or({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[s], Ir(t), _r(t) && (a = !0), i += T(t).charsLeftOver, i += T(t).unusedTokens.length * 10, T(t).score = i, o ? i < r && (r = i, n = t) : (r == null || i < r || a) && (r = i, n = t, a && (o = !0));
  Ue(e, n || t);
}
function sf(e) {
  if (!e._d) {
    var t = Rr(e._i), n = t.day === void 0 ? t.date : t.day;
    e._a = vi(
      [t.year, t.month, n, t.hour, t.minute, t.second, t.millisecond],
      function(r) {
        return r && parseInt(r, 10);
      }
    ), Fr(e);
  }
}
function af(e) {
  var t = new Yt(Lr(Hi(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function Hi(e) {
  var t = e._i, n = e._f;
  return e._locale = e._locale || Le(e._l), t === null || n === void 0 && t === "" ? bn({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), ye(t) ? new Yt(Lr(t)) : (It(t) ? e._d = t : me(n) ? rf(e) : n ? Ir(e) : of(e), _r(e) || (e._d = null), e));
}
function of(e) {
  var t = e._i;
  ie(t) ? e._d = new Date(v.now()) : It(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? Xc(e) : me(t) ? (e._a = vi(t.slice(0), function(n) {
    return parseInt(n, 10);
  }), Fr(e)) : Ge(t) ? sf(e) : Ae(t) ? e._d = new Date(t) : v.createFromInputFallback(e);
}
function Vi(e, t, n, r, s) {
  var i = {};
  return (t === !0 || t === !1) && (r = t, t = void 0), (n === !0 || n === !1) && (r = n, n = void 0), (Ge(e) && vr(e) || me(e) && e.length === 0) && (e = void 0), i._isAMomentObject = !0, i._useUTC = i._isUTC = s, i._l = n, i._i = e, i._f = t, i._strict = r, af(i);
}
function V(e, t, n, r) {
  return Vi(e, t, n, r, !1);
}
var uf = de(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = V.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : bn();
  }
), lf = de(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = V.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : bn();
  }
);
function Bi(e, t) {
  var n, r;
  if (t.length === 1 && me(t[0]) && (t = t[0]), !t.length)
    return V();
  for (n = t[0], r = 1; r < t.length; ++r)
    (!t[r].isValid() || t[r][e](n)) && (n = t[r]);
  return n;
}
function cf() {
  var e = [].slice.call(arguments, 0);
  return Bi("isBefore", e);
}
function ff() {
  var e = [].slice.call(arguments, 0);
  return Bi("isAfter", e);
}
var df = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, xt = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function hf(e) {
  var t, n = !1, r, s = xt.length;
  for (t in e)
    if (F(e, t) && !(q.call(xt, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (r = 0; r < s; ++r)
    if (e[xt[r]]) {
      if (n)
        return !1;
      parseFloat(e[xt[r]]) !== M(e[xt[r]]) && (n = !0);
    }
  return !0;
}
function pf() {
  return this._isValid;
}
function gf() {
  return we(NaN);
}
function Tn(e) {
  var t = Rr(e), n = t.year || 0, r = t.quarter || 0, s = t.month || 0, i = t.week || t.isoWeek || 0, a = t.day || 0, o = t.hour || 0, u = t.minute || 0, l = t.second || 0, f = t.millisecond || 0;
  this._isValid = hf(t), this._milliseconds = +f + l * 1e3 + // 1000
  u * 6e4 + // 1000 * 60
  o * 1e3 * 60 * 60, this._days = +a + i * 7, this._months = +s + r * 3 + n * 12, this._data = {}, this._locale = Le(), this._bubble();
}
function en(e) {
  return e instanceof Tn;
}
function dr(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function mf(e, t, n) {
  var r = Math.min(e.length, t.length), s = Math.abs(e.length - t.length), i = 0, a;
  for (a = 0; a < r; a++)
    (n && e[a] !== t[a] || !n && M(e[a]) !== M(t[a])) && i++;
  return i + s;
}
function zi(e, t) {
  R(e, 0, 0, function() {
    var n = this.utcOffset(), r = "+";
    return n < 0 && (n = -n, r = "-"), r + Oe(~~(n / 60), 2) + t + Oe(~~n % 60, 2);
  });
}
zi("Z", ":");
zi("ZZ", "");
O("Z", xn);
O("ZZ", xn);
j(["Z", "ZZ"], function(e, t, n) {
  n._useUTC = !0, n._tzm = Yr(xn, e);
});
var yf = /([\+\-]|\d\d)/gi;
function Yr(e, t) {
  var n = (t || "").match(e), r, s, i;
  return n === null ? null : (r = n[n.length - 1] || [], s = (r + "").match(yf) || ["-", 0, 0], i = +(s[1] * 60) + M(s[2]), i === 0 ? 0 : s[0] === "+" ? i : -i);
}
function Ur(e, t) {
  var n, r;
  return t._isUTC ? (n = t.clone(), r = (ye(e) || It(e) ? e.valueOf() : V(e).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + r), v.updateOffset(n, !1), n) : V(e).local();
}
function hr(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
v.updateOffset = function() {
};
function wf(e, t, n) {
  var r = this._offset || 0, s;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = Yr(xn, e), e === null)
        return this;
    } else
      Math.abs(e) < 16 && !n && (e = e * 60);
    return !this._isUTC && t && (s = hr(this)), this._offset = e, this._isUTC = !0, s != null && this.add(s, "m"), r !== e && (!t || this._changeInProgress ? Ki(
      this,
      we(e - r, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, v.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? r : hr(this);
}
function Sf(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function bf(e) {
  return this.utcOffset(0, e);
}
function vf(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(hr(this), "m")), this;
}
function _f() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = Yr(jl, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function Of(e) {
  return this.isValid() ? (e = e ? V(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function kf() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function xf() {
  if (!ie(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return Or(e, this), e = Hi(e), e._a ? (t = e._isUTC ? xe(e._a) : V(e._a), this._isDSTShifted = this.isValid() && mf(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function Rf() {
  return this.isValid() ? !this._isUTC : !1;
}
function Ef() {
  return this.isValid() ? this._isUTC : !1;
}
function Gi() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var Tf = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, Df = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function we(e, t) {
  var n = e, r = null, s, i, a;
  return en(e) ? n = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : Ae(e) || !isNaN(+e) ? (n = {}, t ? n[t] = +e : n.milliseconds = +e) : (r = Tf.exec(e)) ? (s = r[1] === "-" ? -1 : 1, n = {
    y: 0,
    d: M(r[be]) * s,
    h: M(r[Q]) * s,
    m: M(r[ge]) * s,
    s: M(r[Pe]) * s,
    ms: M(dr(r[ze] * 1e3)) * s
    // the millisecond decimal point is included in the match
  }) : (r = Df.exec(e)) ? (s = r[1] === "-" ? -1 : 1, n = {
    y: Be(r[2], s),
    M: Be(r[3], s),
    w: Be(r[4], s),
    d: Be(r[5], s),
    h: Be(r[6], s),
    m: Be(r[7], s),
    s: Be(r[8], s)
  }) : n == null ? n = {} : typeof n == "object" && ("from" in n || "to" in n) && (a = Pf(
    V(n.from),
    V(n.to)
  ), n = {}, n.ms = a.milliseconds, n.M = a.months), i = new Tn(n), en(e) && F(e, "_locale") && (i._locale = e._locale), en(e) && F(e, "_isValid") && (i._isValid = e._isValid), i;
}
we.fn = Tn.prototype;
we.invalid = gf;
function Be(e, t) {
  var n = e && parseFloat(e.replace(",", "."));
  return (isNaN(n) ? 0 : n) * t;
}
function Us(e, t) {
  var n = {};
  return n.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(n.months, "M").isAfter(t) && --n.months, n.milliseconds = +t - +e.clone().add(n.months, "M"), n;
}
function Pf(e, t) {
  var n;
  return e.isValid() && t.isValid() ? (t = Ur(t, e), e.isBefore(t) ? n = Us(e, t) : (n = Us(t, e), n.milliseconds = -n.milliseconds, n.months = -n.months), n) : { milliseconds: 0, months: 0 };
}
function qi(e, t) {
  return function(n, r) {
    var s, i;
    return r !== null && !isNaN(+r) && (Oi(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), i = n, n = r, r = i), s = we(n, r), Ki(this, s, e), this;
  };
}
function Ki(e, t, n, r) {
  var s = t._milliseconds, i = dr(t._days), a = dr(t._months);
  e.isValid() && (r = r ?? !0, a && Ci(e, Nt(e, "Month") + a * n), i && Pi(e, "Date", Nt(e, "Date") + i * n), s && e._d.setTime(e._d.valueOf() + s * n), r && v.updateOffset(e, i || a));
}
var Nf = qi(1, "add"), Mf = qi(-1, "subtract");
function Ji(e) {
  return typeof e == "string" || e instanceof String;
}
function Cf(e) {
  return ye(e) || It(e) || Ji(e) || Ae(e) || Lf(e) || Af(e) || e === null || e === void 0;
}
function Af(e) {
  var t = Ge(e) && !vr(e), n = !1, r = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], s, i, a = r.length;
  for (s = 0; s < a; s += 1)
    i = r[s], n = n || F(e, i);
  return t && n;
}
function Lf(e) {
  var t = me(e), n = !1;
  return t && (n = e.filter(function(r) {
    return !Ae(r) && Ji(e);
  }).length === 0), t && n;
}
function Ff(e) {
  var t = Ge(e) && !vr(e), n = !1, r = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], s, i;
  for (s = 0; s < r.length; s += 1)
    i = r[s], n = n || F(e, i);
  return t && n;
}
function If(e, t) {
  var n = e.diff(t, "days", !0);
  return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
}
function Yf(e, t) {
  arguments.length === 1 && (arguments[0] ? Cf(arguments[0]) ? (e = arguments[0], t = void 0) : Ff(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var n = e || V(), r = Ur(n, this).startOf("day"), s = v.calendarFormat(this, r) || "sameElse", i = t && (Re(t[s]) ? t[s].call(this, n) : t[s]);
  return this.format(
    i || this.localeData().calendar(s, this, V(n))
  );
}
function Uf() {
  return new Yt(this);
}
function jf(e, t) {
  var n = ye(e) ? e : V(e);
  return this.isValid() && n.isValid() ? (t = he(t) || "millisecond", t === "millisecond" ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function $f(e, t) {
  var n = ye(e) ? e : V(e);
  return this.isValid() && n.isValid() ? (t = he(t) || "millisecond", t === "millisecond" ? this.valueOf() < n.valueOf() : this.clone().endOf(t).valueOf() < n.valueOf()) : !1;
}
function Wf(e, t, n, r) {
  var s = ye(e) ? e : V(e), i = ye(t) ? t : V(t);
  return this.isValid() && s.isValid() && i.isValid() ? (r = r || "()", (r[0] === "(" ? this.isAfter(s, n) : !this.isBefore(s, n)) && (r[1] === ")" ? this.isBefore(i, n) : !this.isAfter(i, n))) : !1;
}
function Hf(e, t) {
  var n = ye(e) ? e : V(e), r;
  return this.isValid() && n.isValid() ? (t = he(t) || "millisecond", t === "millisecond" ? this.valueOf() === n.valueOf() : (r = n.valueOf(), this.clone().startOf(t).valueOf() <= r && r <= this.clone().endOf(t).valueOf())) : !1;
}
function Vf(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function Bf(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function zf(e, t, n) {
  var r, s, i;
  if (!this.isValid())
    return NaN;
  if (r = Ur(e, this), !r.isValid())
    return NaN;
  switch (s = (r.utcOffset() - this.utcOffset()) * 6e4, t = he(t), t) {
    case "year":
      i = tn(this, r) / 12;
      break;
    case "month":
      i = tn(this, r);
      break;
    case "quarter":
      i = tn(this, r) / 3;
      break;
    case "second":
      i = (this - r) / 1e3;
      break;
    case "minute":
      i = (this - r) / 6e4;
      break;
    case "hour":
      i = (this - r) / 36e5;
      break;
    case "day":
      i = (this - r - s) / 864e5;
      break;
    case "week":
      i = (this - r - s) / 6048e5;
      break;
    default:
      i = this - r;
  }
  return n ? i : ce(i);
}
function tn(e, t) {
  if (e.date() < t.date())
    return -tn(t, e);
  var n = (t.year() - e.year()) * 12 + (t.month() - e.month()), r = e.clone().add(n, "months"), s, i;
  return t - r < 0 ? (s = e.clone().add(n - 1, "months"), i = (t - r) / (r - s)) : (s = e.clone().add(n + 1, "months"), i = (t - r) / (s - r)), -(n + i) || 0;
}
v.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
v.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function Gf() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function qf(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, n = t ? this.clone().utc() : this;
  return n.year() < 0 || n.year() > 9999 ? Xt(
    n,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : Re(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", Xt(n, "Z")) : Xt(
    n,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function Kf() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", n, r, s, i;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), n = "[" + e + '("]', r = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", s = "-MM-DD[T]HH:mm:ss.SSS", i = t + '[")]', this.format(n + r + s + i);
}
function Jf(e) {
  e || (e = this.isUtc() ? v.defaultFormatUtc : v.defaultFormat);
  var t = Xt(this, e);
  return this.localeData().postformat(t);
}
function Zf(e, t) {
  return this.isValid() && (ye(e) && e.isValid() || V(e).isValid()) ? we({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function Qf(e) {
  return this.from(V(), e);
}
function Xf(e, t) {
  return this.isValid() && (ye(e) && e.isValid() || V(e).isValid()) ? we({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function ed(e) {
  return this.to(V(), e);
}
function Zi(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = Le(e), t != null && (this._locale = t), this);
}
var Qi = de(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function Xi() {
  return this._locale;
}
var cn = 1e3, it = 60 * cn, fn = 60 * it, ea = (365 * 400 + 97) * 24 * fn;
function at(e, t) {
  return (e % t + t) % t;
}
function ta(e, t, n) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, n) - ea : new Date(e, t, n).valueOf();
}
function na(e, t, n) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, n) - ea : Date.UTC(e, t, n);
}
function td(e) {
  var t, n;
  if (e = he(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? na : ta, e) {
    case "year":
      t = n(this.year(), 0, 1);
      break;
    case "quarter":
      t = n(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = n(this.year(), this.month(), 1);
      break;
    case "week":
      t = n(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = n(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= at(
        t + (this._isUTC ? 0 : this.utcOffset() * it),
        fn
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= at(t, it);
      break;
    case "second":
      t = this._d.valueOf(), t -= at(t, cn);
      break;
  }
  return this._d.setTime(t), v.updateOffset(this, !0), this;
}
function nd(e) {
  var t, n;
  if (e = he(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? na : ta, e) {
    case "year":
      t = n(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = n(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = n(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = n(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = n(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += fn - at(
        t + (this._isUTC ? 0 : this.utcOffset() * it),
        fn
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += it - at(t, it) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += cn - at(t, cn) - 1;
      break;
  }
  return this._d.setTime(t), v.updateOffset(this, !0), this;
}
function rd() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function sd() {
  return Math.floor(this.valueOf() / 1e3);
}
function id() {
  return new Date(this.valueOf());
}
function ad() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function od() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function ud() {
  return this.isValid() ? this.toISOString() : null;
}
function ld() {
  return _r(this);
}
function cd() {
  return Ue({}, T(this));
}
function fd() {
  return T(this).overflow;
}
function dd() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
R("N", 0, 0, "eraAbbr");
R("NN", 0, 0, "eraAbbr");
R("NNN", 0, 0, "eraAbbr");
R("NNNN", 0, 0, "eraName");
R("NNNNN", 0, 0, "eraNarrow");
R("y", ["y", 1], "yo", "eraYear");
R("y", ["yy", 2], 0, "eraYear");
R("y", ["yyy", 3], 0, "eraYear");
R("y", ["yyyy", 4], 0, "eraYear");
O("N", jr);
O("NN", jr);
O("NNN", jr);
O("NNNN", Od);
O("NNNNN", kd);
j(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, n, r) {
    var s = n._locale.erasParse(e, r, n._strict);
    s ? T(n).era = s : T(n).invalidEra = e;
  }
);
O("y", ct);
O("yy", ct);
O("yyy", ct);
O("yyyy", ct);
O("yo", xd);
j(["y", "yy", "yyy", "yyyy"], te);
j(["yo"], function(e, t, n, r) {
  var s;
  n._locale._eraYearOrdinalRegex && (s = e.match(n._locale._eraYearOrdinalRegex)), n._locale.eraYearOrdinalParse ? t[te] = n._locale.eraYearOrdinalParse(e, s) : t[te] = parseInt(e, 10);
});
function hd(e, t) {
  var n, r, s, i = this._eras || Le("en")._eras;
  for (n = 0, r = i.length; n < r; ++n) {
    switch (typeof i[n].since) {
      case "string":
        s = v(i[n].since).startOf("day"), i[n].since = s.valueOf();
        break;
    }
    switch (typeof i[n].until) {
      case "undefined":
        i[n].until = 1 / 0;
        break;
      case "string":
        s = v(i[n].until).startOf("day").valueOf(), i[n].until = s.valueOf();
        break;
    }
  }
  return i;
}
function pd(e, t, n) {
  var r, s, i = this.eras(), a, o, u;
  for (e = e.toUpperCase(), r = 0, s = i.length; r < s; ++r)
    if (a = i[r].name.toUpperCase(), o = i[r].abbr.toUpperCase(), u = i[r].narrow.toUpperCase(), n)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (o === e)
            return i[r];
          break;
        case "NNNN":
          if (a === e)
            return i[r];
          break;
        case "NNNNN":
          if (u === e)
            return i[r];
          break;
      }
    else if ([a, o, u].indexOf(e) >= 0)
      return i[r];
}
function gd(e, t) {
  var n = e.since <= e.until ? 1 : -1;
  return t === void 0 ? v(e.since).year() : v(e.since).year() + (t - e.offset) * n;
}
function md() {
  var e, t, n, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until || r[e].until <= n && n <= r[e].since)
      return r[e].name;
  return "";
}
function yd() {
  var e, t, n, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until || r[e].until <= n && n <= r[e].since)
      return r[e].narrow;
  return "";
}
function wd() {
  var e, t, n, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until || r[e].until <= n && n <= r[e].since)
      return r[e].abbr;
  return "";
}
function Sd() {
  var e, t, n, r, s = this.localeData().eras();
  for (e = 0, t = s.length; e < t; ++e)
    if (n = s[e].since <= s[e].until ? 1 : -1, r = this.clone().startOf("day").valueOf(), s[e].since <= r && r <= s[e].until || s[e].until <= r && r <= s[e].since)
      return (this.year() - v(s[e].since).year()) * n + s[e].offset;
  return this.year();
}
function bd(e) {
  return F(this, "_erasNameRegex") || $r.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function vd(e) {
  return F(this, "_erasAbbrRegex") || $r.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function _d(e) {
  return F(this, "_erasNarrowRegex") || $r.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function jr(e, t) {
  return t.erasAbbrRegex(e);
}
function Od(e, t) {
  return t.erasNameRegex(e);
}
function kd(e, t) {
  return t.erasNarrowRegex(e);
}
function xd(e, t) {
  return t._eraYearOrdinalRegex || ct;
}
function $r() {
  var e = [], t = [], n = [], r = [], s, i, a, o, u, l = this.eras();
  for (s = 0, i = l.length; s < i; ++s)
    a = Me(l[s].name), o = Me(l[s].abbr), u = Me(l[s].narrow), t.push(a), e.push(o), n.push(u), r.push(a), r.push(o), r.push(u);
  this._erasRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  );
}
R(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
R(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function Dn(e, t) {
  R(0, [e, e.length], 0, t);
}
Dn("gggg", "weekYear");
Dn("ggggg", "weekYear");
Dn("GGGG", "isoWeekYear");
Dn("GGGGG", "isoWeekYear");
O("G", kn);
O("g", kn);
O("GG", B, oe);
O("gg", B, oe);
O("GGGG", Tr, Er);
O("gggg", Tr, Er);
O("GGGGG", On, vn);
O("ggggg", On, vn);
jt(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, n, r) {
    t[r.substr(0, 2)] = M(e);
  }
);
jt(["gg", "GG"], function(e, t, n, r) {
  t[r] = v.parseTwoDigitYear(e);
});
function Rd(e) {
  return ra.call(
    this,
    e,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function Ed(e) {
  return ra.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function Td() {
  return Ce(this.year(), 1, 4);
}
function Dd() {
  return Ce(this.isoWeekYear(), 1, 4);
}
function Pd() {
  var e = this.localeData()._week;
  return Ce(this.year(), e.dow, e.doy);
}
function Nd() {
  var e = this.localeData()._week;
  return Ce(this.weekYear(), e.dow, e.doy);
}
function ra(e, t, n, r, s) {
  var i;
  return e == null ? Ct(this, r, s).year : (i = Ce(e, r, s), t > i && (t = i), Md.call(this, e, t, n, r, s));
}
function Md(e, t, n, r, s) {
  var i = Fi(e, t, n, r, s), a = Mt(i.year, 0, i.dayOfYear);
  return this.year(a.getUTCFullYear()), this.month(a.getUTCMonth()), this.date(a.getUTCDate()), this;
}
R("Q", 0, "Qo", "quarter");
O("Q", xi);
j("Q", function(e, t) {
  t[De] = (M(e) - 1) * 3;
});
function Cd(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
R("D", ["DD", 2], "Do", "date");
O("D", B, ft);
O("DD", B, oe);
O("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
j(["D", "DD"], be);
j("Do", function(e, t) {
  t[be] = M(e.match(B)[0]);
});
var sa = dt("Date", !0);
R("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
O("DDD", _n);
O("DDDD", Ri);
j(["DDD", "DDDD"], function(e, t, n) {
  n._dayOfYear = M(e);
});
function Ad(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
R("m", ["mm", 2], 0, "minute");
O("m", B, Dr);
O("mm", B, oe);
j(["m", "mm"], ge);
var Ld = dt("Minutes", !1);
R("s", ["ss", 2], 0, "second");
O("s", B, Dr);
O("ss", B, oe);
j(["s", "ss"], Pe);
var Fd = dt("Seconds", !1);
R("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
R(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
R(0, ["SSS", 3], 0, "millisecond");
R(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
R(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
R(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
R(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
R(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
R(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
O("S", _n, xi);
O("SS", _n, oe);
O("SSS", _n, Ri);
var je, ia;
for (je = "SSSS"; je.length <= 9; je += "S")
  O(je, ct);
function Id(e, t) {
  t[ze] = M(("0." + e) * 1e3);
}
for (je = "S"; je.length <= 9; je += "S")
  j(je, Id);
ia = dt("Milliseconds", !1);
R("z", 0, 0, "zoneAbbr");
R("zz", 0, 0, "zoneName");
function Yd() {
  return this._isUTC ? "UTC" : "";
}
function Ud() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var w = Yt.prototype;
w.add = Nf;
w.calendar = Yf;
w.clone = Uf;
w.diff = zf;
w.endOf = nd;
w.format = Jf;
w.from = Zf;
w.fromNow = Qf;
w.to = Xf;
w.toNow = ed;
w.get = ql;
w.invalidAt = fd;
w.isAfter = jf;
w.isBefore = $f;
w.isBetween = Wf;
w.isSame = Hf;
w.isSameOrAfter = Vf;
w.isSameOrBefore = Bf;
w.isValid = ld;
w.lang = Qi;
w.locale = Zi;
w.localeData = Xi;
w.max = lf;
w.min = uf;
w.parsingFlags = cd;
w.set = Kl;
w.startOf = td;
w.subtract = Mf;
w.toArray = ad;
w.toObject = od;
w.toDate = id;
w.toISOString = qf;
w.inspect = Kf;
typeof Symbol < "u" && Symbol.for != null && (w[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
w.toJSON = ud;
w.toString = Gf;
w.unix = sd;
w.valueOf = rd;
w.creationData = dd;
w.eraName = md;
w.eraNarrow = yd;
w.eraAbbr = wd;
w.eraYear = Sd;
w.year = Di;
w.isLeapYear = Gl;
w.weekYear = Rd;
w.isoWeekYear = Ed;
w.quarter = w.quarters = Cd;
w.month = Ai;
w.daysInMonth = sc;
w.week = w.weeks = dc;
w.isoWeek = w.isoWeeks = hc;
w.weeksInYear = Pd;
w.weeksInWeekYear = Nd;
w.isoWeeksInYear = Td;
w.isoWeeksInISOWeekYear = Dd;
w.date = sa;
w.day = w.days = Rc;
w.weekday = Ec;
w.isoWeekday = Tc;
w.dayOfYear = Ad;
w.hour = w.hours = Lc;
w.minute = w.minutes = Ld;
w.second = w.seconds = Fd;
w.millisecond = w.milliseconds = ia;
w.utcOffset = wf;
w.utc = bf;
w.local = vf;
w.parseZone = _f;
w.hasAlignedHourOffset = Of;
w.isDST = kf;
w.isLocal = Rf;
w.isUtcOffset = Ef;
w.isUtc = Gi;
w.isUTC = Gi;
w.zoneAbbr = Yd;
w.zoneName = Ud;
w.dates = de(
  "dates accessor is deprecated. Use date instead.",
  sa
);
w.months = de(
  "months accessor is deprecated. Use month instead",
  Ai
);
w.years = de(
  "years accessor is deprecated. Use year instead",
  Di
);
w.zone = de(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  Sf
);
w.isDSTShifted = de(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  xf
);
function jd(e) {
  return V(e * 1e3);
}
function $d() {
  return V.apply(null, arguments).parseZone();
}
function aa(e) {
  return e;
}
var I = kr.prototype;
I.calendar = xl;
I.longDateFormat = Dl;
I.invalidDate = Nl;
I.ordinal = Al;
I.preparse = aa;
I.postformat = aa;
I.relativeTime = Fl;
I.pastFuture = Il;
I.set = Ol;
I.eras = hd;
I.erasParse = pd;
I.erasConvertYear = gd;
I.erasAbbrRegex = vd;
I.erasNameRegex = bd;
I.erasNarrowRegex = _d;
I.months = ec;
I.monthsShort = tc;
I.monthsParse = rc;
I.monthsRegex = ac;
I.monthsShortRegex = ic;
I.week = uc;
I.firstDayOfYear = fc;
I.firstDayOfWeek = cc;
I.weekdays = vc;
I.weekdaysMin = Oc;
I.weekdaysShort = _c;
I.weekdaysParse = xc;
I.weekdaysRegex = Dc;
I.weekdaysShortRegex = Pc;
I.weekdaysMinRegex = Nc;
I.isPM = Cc;
I.meridiem = Fc;
function dn(e, t, n, r) {
  var s = Le(), i = xe().set(r, t);
  return s[n](i, e);
}
function oa(e, t, n) {
  if (Ae(e) && (t = e, e = void 0), e = e || "", t != null)
    return dn(e, t, n, "month");
  var r, s = [];
  for (r = 0; r < 12; r++)
    s[r] = dn(e, r, n, "month");
  return s;
}
function Wr(e, t, n, r) {
  typeof e == "boolean" ? (Ae(t) && (n = t, t = void 0), t = t || "") : (t = e, n = t, e = !1, Ae(t) && (n = t, t = void 0), t = t || "");
  var s = Le(), i = e ? s._week.dow : 0, a, o = [];
  if (n != null)
    return dn(t, (n + i) % 7, r, "day");
  for (a = 0; a < 7; a++)
    o[a] = dn(t, (a + i) % 7, r, "day");
  return o;
}
function Wd(e, t) {
  return oa(e, t, "months");
}
function Hd(e, t) {
  return oa(e, t, "monthsShort");
}
function Vd(e, t, n) {
  return Wr(e, t, n, "weekdays");
}
function Bd(e, t, n) {
  return Wr(e, t, n, "weekdaysShort");
}
function zd(e, t, n) {
  return Wr(e, t, n, "weekdaysMin");
}
$e("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, n = M(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + n;
  }
});
v.lang = de(
  "moment.lang is deprecated. Use moment.locale instead.",
  $e
);
v.langData = de(
  "moment.langData is deprecated. Use moment.localeData instead.",
  Le
);
var Ee = Math.abs;
function Gd() {
  var e = this._data;
  return this._milliseconds = Ee(this._milliseconds), this._days = Ee(this._days), this._months = Ee(this._months), e.milliseconds = Ee(e.milliseconds), e.seconds = Ee(e.seconds), e.minutes = Ee(e.minutes), e.hours = Ee(e.hours), e.months = Ee(e.months), e.years = Ee(e.years), this;
}
function ua(e, t, n, r) {
  var s = we(t, n);
  return e._milliseconds += r * s._milliseconds, e._days += r * s._days, e._months += r * s._months, e._bubble();
}
function qd(e, t) {
  return ua(this, e, t, 1);
}
function Kd(e, t) {
  return ua(this, e, t, -1);
}
function js(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function Jd() {
  var e = this._milliseconds, t = this._days, n = this._months, r = this._data, s, i, a, o, u;
  return e >= 0 && t >= 0 && n >= 0 || e <= 0 && t <= 0 && n <= 0 || (e += js(pr(n) + t) * 864e5, t = 0, n = 0), r.milliseconds = e % 1e3, s = ce(e / 1e3), r.seconds = s % 60, i = ce(s / 60), r.minutes = i % 60, a = ce(i / 60), r.hours = a % 24, t += ce(a / 24), u = ce(la(t)), n += u, t -= js(pr(u)), o = ce(n / 12), n %= 12, r.days = t, r.months = n, r.years = o, this;
}
function la(e) {
  return e * 4800 / 146097;
}
function pr(e) {
  return e * 146097 / 4800;
}
function Zd(e) {
  if (!this.isValid())
    return NaN;
  var t, n, r = this._milliseconds;
  if (e = he(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + r / 864e5, n = this._months + la(t), e) {
      case "month":
        return n;
      case "quarter":
        return n / 3;
      case "year":
        return n / 12;
    }
  else
    switch (t = this._days + Math.round(pr(this._months)), e) {
      case "week":
        return t / 7 + r / 6048e5;
      case "day":
        return t + r / 864e5;
      case "hour":
        return t * 24 + r / 36e5;
      case "minute":
        return t * 1440 + r / 6e4;
      case "second":
        return t * 86400 + r / 1e3;
      case "millisecond":
        return Math.floor(t * 864e5) + r;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function Fe(e) {
  return function() {
    return this.as(e);
  };
}
var ca = Fe("ms"), Qd = Fe("s"), Xd = Fe("m"), eh = Fe("h"), th = Fe("d"), nh = Fe("w"), rh = Fe("M"), sh = Fe("Q"), ih = Fe("y"), ah = ca;
function oh() {
  return we(this);
}
function uh(e) {
  return e = he(e), this.isValid() ? this[e + "s"]() : NaN;
}
function qe(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var lh = qe("milliseconds"), ch = qe("seconds"), fh = qe("minutes"), dh = qe("hours"), hh = qe("days"), ph = qe("months"), gh = qe("years");
function mh() {
  return ce(this.days() / 7);
}
var Te = Math.round, rt = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function yh(e, t, n, r, s) {
  return s.relativeTime(t || 1, !!n, e, r);
}
function wh(e, t, n, r) {
  var s = we(e).abs(), i = Te(s.as("s")), a = Te(s.as("m")), o = Te(s.as("h")), u = Te(s.as("d")), l = Te(s.as("M")), f = Te(s.as("w")), d = Te(s.as("y")), h = i <= n.ss && ["s", i] || i < n.s && ["ss", i] || a <= 1 && ["m"] || a < n.m && ["mm", a] || o <= 1 && ["h"] || o < n.h && ["hh", o] || u <= 1 && ["d"] || u < n.d && ["dd", u];
  return n.w != null && (h = h || f <= 1 && ["w"] || f < n.w && ["ww", f]), h = h || l <= 1 && ["M"] || l < n.M && ["MM", l] || d <= 1 && ["y"] || ["yy", d], h[2] = t, h[3] = +e > 0, h[4] = r, yh.apply(null, h);
}
function Sh(e) {
  return e === void 0 ? Te : typeof e == "function" ? (Te = e, !0) : !1;
}
function bh(e, t) {
  return rt[e] === void 0 ? !1 : t === void 0 ? rt[e] : (rt[e] = t, e === "s" && (rt.ss = t - 1), !0);
}
function vh(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var n = !1, r = rt, s, i;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (n = e), typeof t == "object" && (r = Object.assign({}, rt, t), t.s != null && t.ss == null && (r.ss = t.s - 1)), s = this.localeData(), i = wh(this, !n, r, s), n && (i = s.pastFuture(+this, i)), s.postformat(i);
}
var Jn = Math.abs;
function et(e) {
  return (e > 0) - (e < 0) || +e;
}
function Pn() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = Jn(this._milliseconds) / 1e3, t = Jn(this._days), n = Jn(this._months), r, s, i, a, o = this.asSeconds(), u, l, f, d;
  return o ? (r = ce(e / 60), s = ce(r / 60), e %= 60, r %= 60, i = ce(n / 12), n %= 12, a = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", u = o < 0 ? "-" : "", l = et(this._months) !== et(o) ? "-" : "", f = et(this._days) !== et(o) ? "-" : "", d = et(this._milliseconds) !== et(o) ? "-" : "", u + "P" + (i ? l + i + "Y" : "") + (n ? l + n + "M" : "") + (t ? f + t + "D" : "") + (s || r || e ? "T" : "") + (s ? d + s + "H" : "") + (r ? d + r + "M" : "") + (e ? d + a + "S" : "")) : "P0D";
}
var L = Tn.prototype;
L.isValid = pf;
L.abs = Gd;
L.add = qd;
L.subtract = Kd;
L.as = Zd;
L.asMilliseconds = ca;
L.asSeconds = Qd;
L.asMinutes = Xd;
L.asHours = eh;
L.asDays = th;
L.asWeeks = nh;
L.asMonths = rh;
L.asQuarters = sh;
L.asYears = ih;
L.valueOf = ah;
L._bubble = Jd;
L.clone = oh;
L.get = uh;
L.milliseconds = lh;
L.seconds = ch;
L.minutes = fh;
L.hours = dh;
L.days = hh;
L.weeks = mh;
L.months = ph;
L.years = gh;
L.humanize = vh;
L.toISOString = Pn;
L.toString = Pn;
L.toJSON = Pn;
L.locale = Zi;
L.localeData = Xi;
L.toIsoString = de(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  Pn
);
L.lang = Qi;
R("X", 0, 0, "unix");
R("x", 0, 0, "valueOf");
O("x", kn);
O("X", $l);
j("X", function(e, t, n) {
  n._d = new Date(parseFloat(e) * 1e3);
});
j("x", function(e, t, n) {
  n._d = new Date(M(e));
});
//! moment.js
v.version = "2.30.1";
vl(V);
v.fn = w;
v.min = cf;
v.max = ff;
v.now = df;
v.utc = xe;
v.unix = jd;
v.months = Wd;
v.isDate = It;
v.locale = $e;
v.invalid = bn;
v.duration = we;
v.isMoment = ye;
v.weekdays = Vd;
v.parseZone = $d;
v.localeData = Le;
v.isDuration = en;
v.monthsShort = Hd;
v.weekdaysMin = zd;
v.defineLocale = Ar;
v.updateLocale = jc;
v.locales = $c;
v.weekdaysShort = Bd;
v.normalizeUnits = he;
v.relativeTimeRounding = Sh;
v.relativeTimeThreshold = bh;
v.calendarFormat = If;
v.prototype = w;
v.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
function Ph(e, t) {
  const n = async (u) => await ee.get(`${e}/v2/quotas/${u}`, t).then((l) => l.data), r = async (u) => await ee.get(`${e}/v2/store/apps?workspace_id=${u}`, t).then((l) => l.data.content), s = async (u) => await ee.get(`${e}/v2/workspaces/${u}/contracts?size=${Number.MAX_SAFE_INTEGER}`, t).then((l) => l.data.content), i = async (u) => await ee.get(`${e}/v2/contracts/${u}/entities?size=${Number.MAX_SAFE_INTEGER}`, t).then((l) => l.data.content), a = async (u) => (await ee.post(
    `${e}/v2/auth/verify`,
    { operations: u },
    t
  )).data, o = async (u, l = 0, f = !1) => ee.get(
    `${e}/v2/orgs?attributes=workspaces,total_area&workspaces=${u}` + (f ? `&force_list_unexplicit_orgs=true&size=20&page=${l}` : ""),
    t
  );
  return {
    verifyPermissions: a,
    loadAppsAndContracts: async (u) => {
      const l = (S) => v(/* @__PURE__ */ new Date()).isBetween(S.start, S.end), f = async (S, p, y, _) => {
        const x = await n(S.id);
        return {
          id: p.app_id,
          name: _.name,
          icon: _.icon_uri,
          contractId: p.id,
          quotaId: S.id,
          total: S.limit,
          assigned: S.usage,
          refundable: x.refundable,
          ...y.reduce(
            (k, P) => (k.usageByEntity[P.entity_id] = P.value, k.allocationByEntity[P.entity_id] = P.allocation_date, k),
            {
              usageByEntity: {},
              allocationByEntity: {}
            }
          )
        };
      }, d = (S) => Object.keys(S).sort((p, y) => S[p].name.localeCompare(S[y].name)).reduce((p, y) => (p[y] = S[y], p), {});
      return (async () => {
        const [S, p] = await Promise.all([
          r(u),
          s(u)
        ]), y = {}, _ = {};
        return await Promise.all(
          p.map(async (x) => {
            var k;
            if (l(x) && ((k = x.quotas) != null && k.length)) {
              const P = x.quotas.find(
                (W) => W.entity_type === "FIELD"
                /* FIELD */
              ), D = x.quotas.find(
                (W) => W.entity_type === "ORGANIZATION"
                /* ORGANIZATION */
              ), U = S.find((W) => W.id === x.app_id), $ = await i(x.id);
              U && P && (y[x.app_id] = await f(
                P,
                x,
                $.filter(
                  (W) => W.entity_type === "FIELD"
                  /* FIELD */
                ),
                U
              )), U && D && (_[x.app_id] = await f(
                D,
                x,
                $.filter(
                  (W) => W.entity_type === "ORGANIZATION"
                  /* ORGANIZATION */
                ),
                U
              ));
            }
          })
        ), {
          fieldQuotaByApp: d(y),
          organizationQuotaByApp: d(_)
        };
      })();
    },
    loadActiveSeasonFields: async (u) => (await ee.get(
      `${e}/v2/properties/${u}/season-fields`,
      t
    )).data.content.filter((f) => new Date(f.end_date) > /* @__PURE__ */ new Date()),
    loadOrganizations: async (u) => {
      const { allowed_operations: l } = await a([
        { resource: "crn:system", action: "members:write" }
      ]), f = l.length === 1, d = await o(u, 0, f);
      if (d.data.total_pages > 1) {
        const h = [];
        for (let p = 1; p < d.data.total_pages; p++)
          h.push(o(u, p, f));
        const S = await Promise.all(h);
        return [
          ...d.data.content,
          ...S.reduce((p, y) => [...p, ...y.data.content], [])
        ];
      }
      return d.data.content;
    },
    loadProperties: async (u) => ee.get(`${e}/v2/orgs/${u}/properties`, t).then((l) => l.data.content),
    loadFields: async (u) => (await ee.get(
      `${e}/v2/properties/${u}/fields?attributes=geometry`,
      t
    )).data.content.map((f) => ({ ...f, area: f.calculated_area ?? f.declared_area })).filter((f) => !!f.area).filter((f) => !!f.geometry),
    saveContractEntities: async (u) => {
      const l = [], f = u.selectedApp ? u.fieldQuotaByApp.data[u.selectedApp] : null;
      if (f) {
        const d = Object.keys(f.usageByEntity), h = u.selectedFields, S = d.filter(
          (_) => !h.includes(_)
        ), p = h.filter((_) => !d.includes(_)), y = Object.entries(u.selectedUpdatedFields).filter(([, _]) => _).map(([_]) => _);
        S.length > 0 && l.push(
          ee.delete(
            `${e}/v2/contracts/${f.contractId}/entities`,
            {
              ...t,
              data: S
            }
          )
        ), (p.length > 0 || y.length > 0) && l.push(
          ee.post(
            `${e}/v2/contracts/${f.contractId}/entities`,
            {
              quota: f.quotaId,
              entities: [...p, ...y].map((_) => {
                var x;
                return {
                  key: _,
                  value: (x = u.fields.data.find((k) => k.id === _)) == null ? void 0 : x.area
                };
              })
            },
            t
          )
        );
      }
      return Promise.all(l);
    },
    saveOrganizationQuota: async (u) => {
      const l = [], f = u.selectedApp ? u.organizationQuotaByApp.data[u.selectedApp] : null;
      if (f) {
        const d = f.usageByEntity, h = [], S = [];
        Object.entries(u.orgQuotasCurrentValue).forEach(([p, y]) => {
          d[p] && d[p] !== y && h.push(p), (!d[p] || d[p] !== y) && S.push({
            orgId: p,
            value: y
          });
        }), Object.keys(d).forEach((p) => {
          u.orgQuotasCurrentValue[p] || h.push(p);
        }), h.length > 0 && l.push(
          ee.delete(
            `${e}/v2/contracts/${f.contractId}/entities?entity_type=ORGANIZATION`,
            {
              ...t,
              data: h
            }
          )
        ), S.length > 0 && l.push(
          ee.post(
            `${e}/v2/contracts/${f.contractId}/entities`,
            {
              quota: f.quotaId,
              entities: S.map((p) => ({
                key: p.orgId,
                value: p.value
              }))
            },
            t
          )
        );
      }
      return Promise.all(l);
    }
  };
}
const J = class J {
};
J.config = Sn(), J.$getAllProperties = {}, J.getAllProperties = (t) => (J.$getAllProperties[t] || (J.$getAllProperties[t] = ee.get(
  `${J.config.getAPIURL()}/v2/orgs/${t}/properties`,
  {
    headers: J.config.getDefaultHeaders()
  }
)), J.$getAllProperties[t]), J.getCurrentUser = async () => {
  if (!J.$getCurrentUser) {
    if (!J.config.getToken() || !J.config.getCurrentEnv())
      return null;
    const t = `${J.config.getAPIURL()}/v2/accounts/me`;
    J.$getCurrentUser = ee.get(t, {
      headers: {
        ...J.config.getDefaultHeaders()
      },
      params: {
        attributes: "licensing_accounts,is_using_rbac",
        ...J.config.getExcludeAuthorities() && { exclude_attributes: "authorities" }
      }
    }).then((n) => (J.config.getUserCallback(n.data), n.data));
  }
  return J.$getCurrentUser;
};
let $s = J;
const ht = Sn();
function _h(e) {
  ht.setToken(e);
}
function Oh(e) {
  ht.setupAxiosInterceptor(e);
}
function kh(e) {
  ht.setCurrentAppId(e);
}
function xh(e) {
  return ht.setUserCallback(e);
}
function Rh(e) {
  ht.setExcludeAuthorities(e);
}
function Nh({
  environment: e,
  token: t,
  currentAppId: n,
  axiosInstance: r,
  getCurrentUserCallback: s,
  excludeAuthorities: i = !0
}) {
  ht.setCurrentEnv(e), t && _h(t), r && Oh(r), n && kh(n), s && xh(s), i && Rh(i);
}
export {
  nt as CWElementsConfig,
  Jo as CWElementsI18NProvider,
  $s as CWElementsSharedService,
  Ph as QuotaMgtService,
  Dh as i18nInstance,
  Nh as initCWElements,
  Th as loadPackageTranslations,
  Si as passThroughResponseInterceptor,
  ee as request,
  wi as sessionExpiredInterceptor,
  kh as setCurrentAppId,
  Rh as setExcludeAuthorities,
  _h as setToken,
  xh as setUserCallback,
  Oh as setupAxiosInterceptor,
  Sn as useConfig,
  Zo as useTranslation
};
